import {
  Dimensions,
  StyleSheet,
  TouchableOpacity,
  Modal,
  View,
  Alert,
} from "react-native";
import CustomText from "../../accessories/CustomText";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import CustomCheckBoxSelection from "../../accessories/CustomCheckBoxSelection";
import {
  cleanValue,
  handleAPI,
  formatPercentage,
  generateBoxShadowStyle,
  testSSN,
  handleGetZipCodeDetails,
  formatSSN,
  formatCurrency,
  sortByKeyNumber,
} from "../../accessories/CommonFunctions";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import {
  context,
  InputBox,
  ModalButton,
  Option,
  Title,
} from "../../accessories/accessories";
import ArrowSpinner from "../../accessories/ArrowSpinner";
import { android, ios, web } from "../../accessories/Platform";
import Dropdown from "../../accessories/DropDown";
import XMLParser from "react-xml-parser";
import { LinearGradient } from "expo-linear-gradient";
import ScrollContainer from "../../accessories/ScrollContainer";
import RadioButtonGroup, {
  RadioButtonItem,
} from "../../accessories/RadioButtonGroup";
import DropDownButton from "../../accessories/DropDownButton";
import CustomTextInput from "../../accessories/CustomTextInput";

const isSmallScreen =
    (web && window.innerWidth < 900) || Dimensions.get("window").width < 900,
  isMobileWeb = Dimensions.get("window").width <= 480;

const loanProgramTypeOptions = [
    { value: 2, label: "Conventional" },
    { value: 128, label: "FHA" },
    { value: 2048, label: "VA" },
    { value: 4161552, label: "Other" },
  ],
  loanTermOptions = [
    { value: 64, label: "30 Years" },
    { value: 32, label: "25 Years" },
    { value: 16, label: "20 Years" },
    { value: 8, label: "15 Years" },
    { value: 4, label: "10 Years" },
    { value: 2, label: "7 Years" },
    { value: 1, label: "5 Years" },
    // { value: 128, label: "40 Years" },
  ],
  amortTypeOptions = [
    { value: 1, label: "Fixed Rate" },
    { value: 4, label: "ARM" },
    { value: 32, label: "Buydown" },
    { value: 474, label: "Other" },
  ],
  lienPositionOptions = [
    { value: 1, label: "1st" },
    { value: 2, label: "2nd" },
  ],
  lockPeriodOptions = [
    { value: "0", label: "Select" },
    { value: "2", label: "12" },
    { value: "4", label: "30" },
    { value: "5", label: "45" },
    { value: "6", label: "60" },
    { value: "7", label: "75" },
    { value: "8", label: "90" },
    { value: "9", label: "120" },
    { value: "10", label: "150" },
    { value: "11", label: "180" },
  ];
const formatDate = (dateString) => {
  try {
    const [month, day, year] = dateString.split("/"),
      date = new Date(`${year}-${month}-${day}`),
      daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      monthsOfYear = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      dayName = daysOfWeek[date.getDay()],
      monthName = monthsOfYear[date.getMonth()];

    return `${dayName}, ${monthName} ${day}, ${year}`;
  } catch (error) {
    console.log("Error in date format");
    return null;
  }
};
const IsLoanProgramSelected = async (LoanId, callBack = () => {}) => {
  return await handleAPI({
    name: "IsLoanProgramSelected",
    params: { LoanId },
    apiName: "GenericAPI",
    method: "GET",
  }).then((response) => {
    const iIsSelected = JSON["parse"](response)["Table"][0]["Column1"] > 0;
    callBack(iIsSelected);
    return iIsSelected;
  });
};

const getPoints = (points) => {
  if (points < 0) {
    return `(${formatPercentage(points * -1)})`;
  }
  return formatPercentage(points);
};
const removeUnwantedBitwise = (bitwise, options) => {
  let filteredValue = 0;
  options.forEach((option) => {
    if ((bitwise & option.value) === option.value) {
      filteredValue |= option.value;
    }
  });

  return filteredValue;
};
const fnGetIndex = (data, key) => {
  let Index = data.findIndex((e) => Object.keys(e) == key);
  return Index;
};

const Button = ({
  disabled = false,
  onPress = () => {},
  title = <></>,
  style = {},
  buttonType = "primary",
}) => {
  return (
    <ModalButton
      disabled={buttonType == "primary" && disabled}
      onPress={onPress}
      title={title}
      buttonType={buttonType}
      style={[
        {
          alignSelf: "center",
          padding: 20,
          height: web ? 43 : 40,
          display: "flex",
          alignItems: "center",
          width: "100%",
          borderRadius: 8,
        },
        buttonType == "primary"
          ? {
              backgroundColor: "#508BC9",
              borderColor: !disabled ? "#295B9A" : "",
              borderWidth: !disabled ? 1 : 0,
            }
          : {
              backgroundColor: disabled ? "#f2f2f2" : "#fff",
              borderWidth: 3,
              borderColor: "#508BC9",
            },
        style,
        web
          ? {
              boxShadow: "rgba(0, 0, 0, 30%) 0px 4px 6px",
              cursor: disabled ? "not-allowed" : "pointer",
            }
          : generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
      ]}
      textStyle={{
        marginTop: web ? "-3px" : 0,
      }}
    />
  );
};
const RateOption = ({ onPress = () => {}, children, disable = false }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      <LinearGradient
        colors={["#404040", "#232323", "#232323"]}
        style={{
          alignItems: "center",
          justifyContent: "space-evenly",
          width: web ? 250 : 190,
        }}
      >
        <TouchableOpacity
          style={[
            {
              paddingHorizontal: 10,
              paddingVertical: web ? 14 : 8,
              borderWidth: 1,
              borderColor: "#5f5f5f",
              width: "100%",
              opacity: disable ? 0.5 : 1,
            },
            isHovered && {
              backgroundColor: "#6c757d",
            },
          ]}
          onPress={onPress}
          activeOpacity={1}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <CustomText
            bold
            style={[
              {
                color: "#fff",
                fontSize: web ? 14 : 12,
              },

              web && {
                fontWeight: "500",
              },
            ]}
            onPress={onPress}
          >
            {children}
          </CustomText>
        </TouchableOpacity>
      </LinearGradient>
    </>
  );
};
const handleGetShortLoanProductName = async (progName) => {
  return await handleAPI({
    name: "GetShortLoanProgram",
    params: { progName },
  }).then((response) => {
    return response;
  });
};
const IsLockedLoan = async (LoanId) => {
  return await handleAPI({
    name: "IsLoanLocked",
    params: { LoanId },
    apiName: "RateLockAPI",
  }).then((response) => {
    return response;
  });
};
const RateRow = forwardRef((props, ref) => {
  const { backgroundColor, children } = props,
    handlePress = () => {
      if (props.onPress) {
        props.onPress();
      }
    };

  useImperativeHandle(ref, () => ({
    triggerPress: handlePress,
  }));

  return (
    <TouchableOpacity
      style={[
        styles["rateTableRow"],
        {
          backgroundColor,
          borderBottomColor: "#a5a5a5",
          borderBottomWidth: 1,
        },
      ]}
      activeOpacity={0.8}
      onPress={handlePress}
    >
      {children}
    </TouchableOpacity>
  );
});

const handleGetJournalPost = async (LoanId) => {
  return await handleAPI({
    name: "getJournalPostStatus",
    params: { LoanId },
    apiName: "RateLockAPI",
  }).then((response) => {
    return response;
  });
};
const handleUnPostJournal = async (XmlDataIn) => {
  return await handleAPI({
    name: "getJournalPostStatus",
    params: { XmlDataIn },
  }).then((response) => {
    return response;
  });
};
const SaveLockRateCancelReason = async (
  Loanid,
  EmpNum,
  CancelReason,
  CancelType
) => {
  return await handleAPI({
    name: "SaveLockRateCancelReason",
    params: {
      Loanid,
      EmpNum,
      CancelReason: CancelReason || "",
      CancelType,
    },
  }).then((response) => {
    return response;
  });
};
const getMidRate = async (LoanID, callBack = () => {}) => {
  handleAPI({
    name: "GetMidRate",
    params: { LoanID },
    apiName: "GenericAPI",
    method: "POST",
  }).then((response) => {
    callBack(JSON.parse(response)[0]);
  });
};
const handleGetLimitedRateArray = (
    midRateDetails = {},
    rowData,
    COlID,
    totalAddons
  ) => {
    let {
      chargerebate: chargeRebate,
      nearestcharge: nearestCharge,
      ratemethod: rateMethod,
      ratetarget: rateTarget,
    } = midRateDetails;

    /*  
    rateMethod = 1; --desired rate
    rateTarget = 8.625;


    rateMethod = 2; --rate formula
    nearestCharge = 1; 1 --equal and above,2 --equal or below
    chargeRebate = 1.889;
    */

    let midRate = 0,
      filteredRatesArray = [];

    if (rateMethod == 1) {
      midRate = Number(cleanValue(rateTarget));
    } else if (rateMethod == 2) {
      rowData = rowData.map((row) => {
        row["finalPoints"] = Number(
          cleanValue(getPoints(parseFloat(row[COlID]) + totalAddons))
        );
        return row;
      });

      // if (nearestCharge === 1) {
      //   //Equal or Above
      //   filteredRatesArray = rowData.filter(
      //     ({ finalPoints }) => finalPoints >= chargeRebate
      //   );
      //   if (filteredRatesArray.length === 0) {
      //     filteredRatesArray = sortByKeyNumber(rowData, "finalPoints", !true);
      //   } else {
      //     filteredRatesArray = sortByKeyNumber(
      //       filteredRatesArray,
      //       "finalPoints",
      //       true
      //     );
      //   }
      // } else {
      //   //Equal or Below
      //   filteredRatesArray = rowData.filter(
      //     ({ finalPoints }) => finalPoints <= chargeRebate
      //   );
      //   if (filteredRatesArray.length === 0) {
      //     filteredRatesArray = sortByKeyNumber(rowData, "finalPoints", !false);
      //   } else {
      //     filteredRatesArray = sortByKeyNumber(
      //       filteredRatesArray,
      //       "finalPoints",
      //       false
      //     );
      //   }
      // }

      // Determine the comparison based on nearestCharge
      const compare = nearestCharge === 1 ? (a, b) => a >= b : (a, b) => a <= b;

      filteredRatesArray = rowData.filter(({ finalPoints }) =>
        compare(finalPoints, chargeRebate)
      );

      filteredRatesArray = filteredRatesArray.length
        ? sortByKeyNumber(
            filteredRatesArray,
            "finalPoints",
            nearestCharge === 1
          )
        : sortByKeyNumber(rowData, "finalPoints", nearestCharge === 1);

      midRate = Number(cleanValue(filteredRatesArray[0]["Rate"]));
    }
    let sRate = roundOfRate(midRate) - 0.25,
      eRate = roundOfRate(midRate) + 0.25;
    return [sRate, midRate, eRate];
  },
  roundOfRate = (rate) => {
    return isFloat(rate / 0.125) ? Math.round(rate) : rate;
  },
  isFloat = (n) => {
    return Number(n) === n && n % 1 !== 0;
  };

const handlePricingError = (params) => {
  handleAPI({
    name: "pricingErrorHanding",
    params,
    apiName: "RateLockAPI",
  }).then((response) => {
    console.log("Mail Queued");
  });
};

const InterestRate = ({
  SessionId,
  loanId,
  userId: EmpNum,
  stateOptions = [],
  userName,
  handleGetLeftNavStatus = () => {},
  LoanData: iLoanData = {},
  handleRequiredFieldData = () => {},
  handleSaveSubjectProperty = () => {},
  propertyTypeOption = [],
  handleCalculateDownPaymentPer = () => {},
  DownPmtOnChange = () => {},
  LnAmtExcChange = () => {},
  CalculateDownPayment = () => {},
  CalculateLnAmt = () => {},
  handleSaveRequiredFields = () => {},
  handleGetBorrowerUrl = () => {},
  handleNextClick = () => {},
}) => {
  const [loanBoardingData, setLoanBoardingData] = useState(null),
    [rateData, setRateData] = useState(null),
    [rowStatus, setRowStatus] = useState([]),
    [searchInfo, setSearchInfo] = useState({ isEditMode: true }),
    [processingStatus, setProcessingStatus] = useState("pageLoading"),
    [selectedRate, setSelectedRate] = useState({}),
    [aprRateState, setAprRateState] = useState({}),
    [cashToCloseDetails, setCashToCloseDetails] = useState({}),
    [rateDisplayDetails, setRateDisplayDetails] = useState({
      expandedLineId: [],
    }),
    // [lockExpDate, setLockExpDate] = useState(null),
    [optionDetails, setOptionDetails] = useState({
      visible: false,
      top: 0,
      left: 0,
      opacity: 0,
    }),
    [priceAvailability, setPriceAvailability] = useState(null),
    [lockConfirmationDetails, setLockConfirmationDetails] = useState({
      lockExpDate: null,
    }),
    [extendDetails, setExtendDetails] = useState([]),
    [floatDownRate, setFloatDownRate] = useState([]),
    [alertDetails, setAlertDetails] = useState({
      visible: false,
      head: "",
      body: "",
    }),
    [modalDetails, setModalDetails] = useState({ visible: false }),
    [loanTermDetails, setLoanTermDetails] = useState({
      isExpand: false,
      viewCount: 4,
      totalCount: loanTermOptions["length"],
    }),
    { contextDetails, setContextDetails } = useContext(context),
    targetRef = useRef(null),
    scrollViewRef = useRef(null),
    OptionButton = useRef(),
    { processName = "rateSelection" } = lockConfirmationDetails,
    [requiredFieldsObj, setRequiredFieldsObj] = useState([]);

  const handleGetRequiredFields = () => {
    let iRequiredFieldsArray = [
      !Number(iLoanData["Propertybe"]) && {
        Title: "Please tell us about your occupancy",
        Options: [
          { value: 1, text: "Primary Residence" },
          { value: 2, text: "Second Home" },
          { value: 3, text: "Investment Property" },
        ],
        ColumnName: "Propertybe",
        type: 1,
      },
      !Number(iLoanData["LoanSummaryPropertyType"]) && {
        Title: "What is the Property Type?",
        label: "Property Type",
        ColumnName: "LoanSummaryPropertyType",
        onBlur: () => {},
        type: 3,
        Option: propertyTypeOption,
        isMap: true,
      },

      !iLoanData["subjectZip"] && {
        Title: "Subject Property Zip Code",
        label: "Zip Code",
        ColumnName: "subjectZip",
        keyboardType: "numeric",
        maxLength: 5,
        type: 2,
      },
    ].filter((_) => _);

    if (iLoanData["LoanPurpose"] === 2 && !iLoanData["Pri_purpose_Refi"]) {
      iRequiredFieldsArray.push({
        Title: "What is the primary purpose of your refinance?",
        Options: [
          { value: 1, text: "Lower my payment" },
          { value: 2, text: "Cash out" },
        ],
        ColumnName: "Pri_purpose_Refi",
        type: 1,
      });
    }
    if (
      iLoanData["LoanPurpose"] == 1 &&
      (!Number(cleanValue(iLoanData["Purchase_Estm_Pur_Price"])) ||
        !Number(cleanValue(iLoanData["Purchase_Estm_LnAmt"])))
    ) {
      iRequiredFieldsArray.push(
        ...[
          {
            Title: "What is the estimated purchase price?",
            label: "Estimated purchase value",
            ColumnName: "Purchase_Estm_Pur_Price",
            isValid: cleanValue(iLoanData["Purchase_Estm_Pur_Price"]) == 0,
            isCurrency: true,
            onBlurFunction: "handleCalculateDownPaymentPer",
          },
          {
            Title: "What is the estimated Down Payment?",
            label: "Down Payment",
            field: [
              {
                ColumnName: "DownPayment",
                ColumnValue: iLoanData["DownPayment"],
                isCurrency: true,
                onBlurFunction: "DownPmtOnChange",
              },
              {
                ColumnName: "DownPaymentPercent",
                ColumnValue: iLoanData["DownPaymentPercent"],
                isCurrency: true,
                onBlurFunction: "CalculateDownPayment",
              },
            ],
          },
          {
            Title: "What would be your estimated loan amount?",
            label: "Estimated Loan Amount",
            ColumnName: "Purchase_Estm_LnAmt",
            isValid: cleanValue(iLoanData["Purchase_Estm_LnAmt"]) == 0,
            isCurrency: true,
            onBlurFunction: "LnAmtExcChange",
          },
        ]
      );
    }

    if (
      iLoanData["LoanPurpose"] == 2 &&
      (!Number(cleanValue(iLoanData["Refi_Estmt_Prop_Lnval"])) ||
        !Number(cleanValue(iLoanData["Refi_Estmt_LnAmt"])))
    ) {
      iRequiredFieldsArray.push(
        ...[
          {
            Title: "What is the estimated property value?",
            label: "Estimated Property Value",
            isValid: cleanValue(iLoanData["Refi_Estmt_Prop_Lnval"]) == 0,
            ColumnName: "Refi_Estmt_Prop_Lnval",
            ColumnValue: iLoanData["Refi_Estmt_Prop_Lnval"],
            isCurrency: true,
            onBlur: () => {
              // setLoanData({
              //   ...iLoanData,
              //   Refi_Estmt_Prop_Lnval: formatCurrency(
              //     LoanData["Refi_Estmt_Prop_Lnval"],
              //     2
              //   ),
              // });
            },
          },
          {
            Title: "Loan Amount of Loan Being Paid Off?",
            label: "Loan Being Paid Off",
            ColumnName: "PaidOff",
            isCurrency: true,
            onBlurFunction: "PaidOff",
            // () => {
            //   CalculateLnAmt("PaidOff");
            // },
          },
          iLoanData["Pri_purpose_Refi"] === 2
            ? {
                Title: "Cash Out Amount Requested?",
                label: "Cash Out Amount",
                ColumnName: "CashOutAmount",
                isCurrency: true,
                onBlurFunction: "CashOutAmount",
                // () => {
                //   CalculateLnAmt("CashOutAmount");
                // },
              }
            : null,
          {
            Title: "What would be your estimated loan amount?",
            label: "Estimated Loan Amount",
            ColumnName: "Refi_Estmt_LnAmt",
            isValid: cleanValue(iLoanData["Refi_Estmt_LnAmt"]) == 0,
            isCurrency: true,
            onBlurFunction: "Refi_Estmt_LnAmt",
            // () => {
            //   CalculateLnAmt("Refi_Estmt_LnAmt");
            // },
          },
        ].filter((_) => _)
      );
    }
    console.log(iRequiredFieldsArray);

    setRequiredFieldsObj(iRequiredFieldsArray);
    return (iRequiredFieldsArray || []).length > 0;
  };

  const handleOpenOption = () => {
    OptionButton.current.measure((_fx, _fy, _w, h, _px, py) => {
      setOptionDetails((prevOptionDetails) => ({
        visible: !prevOptionDetails["visible"],
        top: py + h - (android ? 22 : 0),
        bottom: _fy - (android ? 8 : 0),
        left: _px - 1,
        width: _w - 30,
        opacity: 1,
      }));
    });
  };

  useEffect(() => {
    handleGetLoanBoardingData(undefined, { processName: "selectLoanProduct" });
    getMidRate(loanId, (rateDetails) => {
      setRateDisplayDetails(() => {
        return { expandedLineId: [], ...rateDetails };
      });
    });
  }, []);

  useEffect(() => {
    if (priceAvailability === "priceChanged") {
      setProcessingStatus("pageLoading");
      setTimeout(() => {
        handleGetLoanBoardingData();
      }, 1500);
      setRateData(null);
      handleUpdateSearchInfo("isEditMode", true, false);
      setLoanBoardingData(null);
    }
  }, [priceAvailability]);

  const handleAutoSelectLoanProduct = (needToSelect, callBack = () => {}) => {
    if (needToSelect) {
      setProcessingStatus("autoSelectingProduct");
      handleAPI({
        name: "RunLoanSelection_NewLoan",
        params: {
          LoanId: loanId,
        },
      })
        .then((response) => {
          setTimeout(() => callBack(1), 1000);
        })
        .catch((err) =>
          console.error("Error form RunLoanSelection_NewLoan ====> ", err)
        );
    } else {
      callBack();
    }
  };

  const handleGetLoanBoardingData = async (isLocked, paramsObj = {}) => {
    let { processName } = paramsObj;
    if (processName !== "selectLoanProduct") {
      setProcessingStatus("pageLoading");
    }
    isLocked = [0, 1].includes(isLocked)
      ? isLocked
      : await IsLockedLoan(loanId);

    if (isLocked == 0) {
      if (handleGetRequiredFields()) {
        setProcessingStatus("addressInfoSection-BestFit");
        setModalDetails({
          visible: true,
        });
      } else {
        IsLoanProgramSelected(loanId, (isFloated) => {
          setTimeout(() => {
            setLockConfirmationDetails((prevLockConfirmationDetails) => {
              return {
                ...prevLockConfirmationDetails,
                isFloated,
                isLoadingFloatedRate: true,
              };
            });
          }, 1000);
        });
        handleAutoSelectLoanProduct(
          processName === "selectLoanProduct",
          async (retryCount = 0) => {
            setProcessingStatus("pageLoading");
            handleAPI({
              name: "GetLoanBoardingData",
              apiName: "RateLockAPI",
              params: {
                LoanID: loanId,
                EmpNum,
                WhatProcess: 1,
                Testing: 0,
                SessionId,
              },
            })
              .then(async (response) => {
                response = JSON.parse(response);
                __DEV__ && console.log("response", response);

                let dataOutIndex = fnGetIndex(response["DataOut"], "DataOut"),
                  LineId = 0,
                  IsNoProgramSelected = true;
                if (dataOutIndex != -1) {
                  LineId = Object.keys(
                    response["DataOut"]?.[dataOutIndex]?.["DataOut"]?.[1] || []
                  );
                }

                if (LineId.length && false)
                  LineId = LineId?.[0].split("_")?.[1] || 0;
                else {
                  // let progIndex = fnGetIndex(
                  //   response["DataOut"],
                  //   "ProgramName"
                  // );
                  // IsNoProgramSelected =
                  //   (
                  //     response["DataOut"][progIndex]?.["ProgramName"]?.[0][
                  //       "ProgramName"
                  //     ] || ""
                  //   )?.length == 0;

                  // if (!IsNoProgramSelected) {
                  //   handleCancelConfirmation({
                  //     head: "Error",
                  //     body: "Exception occurred on Loading Selected Loan Product.",
                  //   });
                  //   return;
                  // }

                  let pgIndex = fnGetIndex(
                    response["DataOut"],
                    "LoanSearchInfo"
                  );
                  let { LoanProgNum = "", LoadSelectedProduct = 0 } =
                    response["DataOut"][pgIndex]?.["LoanSearchInfo"]?.[0] || "";
                  if (LoanProgNum.length > 3 && LoadSelectedProduct == 1) {
                    handleSearchLoanProducts({
                      LoanProgNum,
                      loanBoardingData: response,
                    });
                  }
                }
                // if (["changeRate", "floatDown"].includes(processName)) {
                //   let mergedData = response["DataOut"][dataOutIndex],
                //     keysToBeModify = [
                //       "RateCol",
                //       "RateData",
                //       "Addons",
                //       "LockPeriod",
                //     ],
                //     worseCaseRaw = await handleGetChangeRate(LineId),
                //     worseCaseData =
                //       worseCaseRaw?.["DataOut"]?.[1]?.["DataOut"] || [],
                //     obj =
                //       mergedData?.["DataOut"]?.[1]?.[`LineDataOut_${LineId}`];
                //   for (let index = 0; index < obj.length; index++) {
                //     let row = obj[index],
                //       key = Object.keys(row)[0] || "Addons";
                //     if (keysToBeModify.indexOf(key) != -1) {
                //       let point = fnGetIndex(worseCaseData, key),
                //         replacingData = worseCaseData[point]?.[key] || [];
                //       obj[index][key] = replacingData;
                //     }
                //   }
                //   mergedData["DataOut"][1][`LineDataOut_${LineId}`] = obj;
                //   response["DataOut"][dataOutIndex] = mergedData;
                // }

                setLoanBoardingData(response);

                // let iRateData = [
                //   ...(response["DataOut"]?.[7]?.["DataOut"] || []),
                // ];
                // const loanProgramOrder = iRateData.pop();
                // iRateData.shift();

                // const loanProgramsList = await loanProgramOrder[
                //   "LoanProgramsList"
                // ].reduce(async (acc, { LPA_CommonData, CommonProgramName }) => {
                //   acc[LPA_CommonData] = await handleGetShortLoanProductName(
                //     CommonProgramName
                //   );
                //   return acc;
                // }, {});
                // iRateData = replaceLoanProductName(
                //   iRateData,
                //   loanProgramsList,
                //   "LPA_CommonData"
                // );

                // iRateData[0]["isExpand"] = true;
                // let {
                //     LineId: lineId,
                //     LnProgActiveId,
                //     LockDays,
                //     InterestRate,
                //     RateSheetId,
                //   } = Object.values(iRateData[0])[0][1][
                //     "LoanProgramDetails"
                //   ][0],
                //   { LockPeriod = [] } = Object.values(iRateData[0])[0][4];

                // let LockPeriodArray = LockPeriod.filter(
                //   ({ LockExpDate }) => LockExpDate == LockDays
                // );
                // if (LockPeriodArray.length == 0) {
                //   LockPeriodArray = LockPeriod.filter(
                //     ({ LockPeriodID }) => LockPeriodID == 4
                //   );
                // }
                // const { LockPeriods, COlID } = LockPeriodArray[0] || {},
                //   { [COlID]: BasePoints } =
                //     Object.values(iRateData[0])[0][5]["RateData"].filter(
                //       ({ Rate }) => Rate == InterestRate
                //     )?.[0] || {};

                // if (
                //   !["changeRate", "floatDown"].includes(processName) &&
                //   !__DEV__
                // ) {
                //   const iPriceAvailability = await handleGetRateAvailability({
                //     LineId,
                //     RateSheetId,
                //     BaseRate: InterestRate,
                //     BasePoints: BasePoints,
                //     ParPeriod: LockPeriods,
                //   });
                //   setPriceAvailability(iPriceAvailability);
                // }

                // setRateData(iRateData);
                // if (iRateData.length === 0) {
                //   handleUpdateSearchInfo("isEditMode", true, false);
                // }

                // // setSelectedRate({
                // //   Rate: cleanValue(InterestRate),
                // //   LineId: lineId,
                // //   LnProgActiveId,
                // // });

                // handleUpdateSearchInfo("isEditMode", false, false);
                let LoanSearchInfoIndex = fnGetIndex(
                    response["DataOut"],
                    "LoanSearchInfo"
                  ),
                  PropertyInfoIndex = fnGetIndex(
                    response["DataOut"],
                    "PropertyInfo"
                  ),
                  {
                    AmortType,
                    LoanType,
                    Term,
                    LockPeriod: lockPeriod,
                  } = response["DataOut"][LoanSearchInfoIndex][
                    "LoanSearchInfo"
                  ][0],
                  { LienPosition = 1 } =
                    response["DataOut"][PropertyInfoIndex]["PropertyInfo"][0];

                AmortType = removeUnwantedBitwise(AmortType, amortTypeOptions);
                LoanType = removeUnwantedBitwise(
                  LoanType,
                  loanProgramTypeOptions
                );
                Term = removeUnwantedBitwise(Term, loanTermOptions);

                setSearchInfo({
                  amortType: Number(AmortType),
                  loanType: Number(LoanType),
                  term: Number(Term),
                  lienPosition: Number(LienPosition) || 1,
                  lockPeriod: Number(lockPeriod),
                  isEditMode: true,
                });
                setProcessingStatus("searchingProducts");
              })
              .catch((error) => {
                console.error("Error from GetLoanBoardingData ====> ", error);
                if (retryCount === 1) {
                  setProcessingStatus("searchingProducts");
                  handleGetLoanBoardingData(0);
                } else {
                  handleCancelConfirmation({
                    head: "Error",
                    body: "Exception occurred on Loading Selected Loan Product.",
                  });
                  setProcessingStatus(null);
                  setRateData([]);
                  handleUpdateSearchInfo("isEditMode", true, false);
                }
              });
          }
        );
      }
    } else {
      handleGetRateLockDetails();
      // handleGetExtendRateDetails();
      setProcessingStatus(null);
    }
    setLockConfirmationDetails((prevLockConfirmationDetails) => {
      return {
        ...prevLockConfirmationDetails,
        isLocked,
      };
    });
  };
  const handleGetLineIdLockPeriod = ({ rate }) => {
    handleAPI({
      name: "GetCashFromBorr",
      apiName: "GenericAPI",
      params: { loanId },
      method: "GET",
    }).then((response) => {
      const { "Cash To Borrower": cashToClose } =
        JSON.parse(response)["Table"][0];
      setSelectedRate((prevSelectedRate) => {
        return {
          ...prevSelectedRate,
          cashToClose,
        };
      });
    });
    return;
    handleAPI({
      name: "GetLineIdLockPeriod",
      apiName: "GenericAPI",
      params: { loanId },
      method: "GET",
    }).then((response) => {
      const { lineId = 0, lockPeriod = 2 } = JSON.parse(response)["Table"][0];
      if (lineId && lockPeriod) {
        handleGetCashToClose(
          lineId,
          lockPeriod,
          true,
          Number(cleanValue(rate))
        );
      }
    });
  };
  const handleGetMonthlyPayment = () => {
    handleAPI({
      name: "GetMonthlyPayment",
      apiName: "GenericAPI",
      params: { loanId },
      method: "GET",
    })
      .then((response) => {
        const { MonthlyPayment = "-" } = JSON.parse(response)["Table"][0];
        setLockConfirmationDetails((prevLockConfirmationDetails) => {
          return {
            ...prevLockConfirmationDetails,
            MonthlyPayment: MonthlyPayment.toFixed(2),
          };
        });
      })
      .catch((e) => {
        console.error("Error form ====> DoLockRateProcess", e);
      });
  };
  //
  const handleLoanApr = (aprPollingCount = 0) => {
    if (aprPollingCount < 15) {
      handleAPI({
        name: "GetLoanApr",
        apiName: "GenericAPI",
        params: { loanId },
        method: "GET",
      })
        .then((response) => {
          const { TILAPR: APR } = JSON.parse(response)["Table"][0];
          setLockConfirmationDetails((prevLockConfirmationDetails) => {
            return {
              ...prevLockConfirmationDetails,
              APR,
            };
          });

          setTimeout(() => {
            handleLoanApr(aprPollingCount + 1);
          }, 1500);
        })
        .catch((e) => {
          console.error("Error form ====> DoLockRateProcess", e);
        });
    }
  };
  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const formatBaseAmount = (baseamt) => {
    baseamt = baseamt.toFixed(2);
    let value = numberWithCommas(baseamt);
    if (value.toString().includes("-")) {
      value = `($${value.toString().replaceAll("-", "")})`;
    } else value = `$${value}`;
    return value;
  };
  const handleChangeRate = ({ iMessage, closeOnly }) => {
    let {
        allowlockstatus: AllowLockStatus,
        progchanged: progChanged,
        ratesheetused: RateSheetID,
      } = lockConfirmationDetails,
      message = iMessage || "",
      isCloseOnly = closeOnly || false;

    setOptionDetails({
      ...optionDetails,
      visible: false,
    });
    if (!message) {
      if (progChanged == 0) {
        message = (
          <>
            The lock will be priced as of rate sheet id{" "}
            <CustomText bold>{RateSheetID}</CustomText>. Do you want to proceed?
          </>
        );
      } else {
        message =
          "Since this program on this lock has changed the lock may be subject to worse case pricing. Do you want to proceed?";
      }
    }

    handleCancelConfirmation({
      head: "Select a Different Rate",
      body: message,
      needCancel: !isCloseOnly,
      successButtonText: isCloseOnly ? "Ok" : "Proceed",
      preventSuccessPress: true,
      successButtonOnPress: async () => {
        const ChangeRateSet = await handleGetChangeRateSet();
        if (ChangeRateSet != 1) {
          handleCancelConfirmation({
            head: "Error",
            body:
              "Error occurred in setting up the loan for changing the rate " +
              ChangeRateSet +
              ". Please try again or contact support@directcorp.com for additional assistance",
          });
        } else {
          setProcessingStatus(null);
          setRateData(null);
          handleUpdateSearchInfo("isEditMode", true, false);
          setLoanBoardingData(null);
          setLockConfirmationDetails((prevLockConfirmationDetails) => {
            return {
              ...prevLockConfirmationDetails,
              processName: "changeRate",
            };
          });
          handleGetLoanBoardingData(0, { processName: "changeRate" });
          handleSetSessionDataValue();
          setAlertDetails({
            visible: false,
          });
          setModalDetails({
            visible: false,
          });
        }
      },
    });
  };

  const handleFloatDown = () => {
    let {
        allowlockstatus: AllowLockStatus,
        floatdownallowed: FloatDownAllowed,
        showfloatdown: showFloatDown,
        maximumFloatDown: MaxFloatDownAllowed,
        floatdownflag: FloatDownFlag,
      } = lockConfirmationDetails,
      message = "",
      isCloseOnly = true;

    setOptionDetails({
      ...optionDetails,
      visible: false,
    });

    if (FloatDownFlag == 1) {
      message =
        "The Float Down Option has already been used and can only be used once.";
    } else if (FloatDownAllowed == 0) {
      message = "The Float Down Option is not allowed on this program.";
    } else if (showFloatDown == 0) {
      message = (
        <CustomText>
          The rate lock is no longer eligible to Float Down because it has
          reached the maximum{" "}
          <CustomText bold>{MaxFloatDownAllowed}</CustomText>
          {". "}Float down(s) allowed. Please contact the Lock Desk if you need
          additional assistance.
        </CustomText>
      );
    } else if (FloatDownAllowed == 3) {
      message =
        "This lock is not eligible for a float-down because the loan amount falls within the new, temporary FHA loan amount limits.";
    } else {
      isCloseOnly = false;
      message = `Selecting the Float Down option may cause your expiration date to change, so please note your new expiration date.${"\n"}${"\n"}Do you want to proceed?`;
    }
    handleCancelConfirmation({
      head: "Float Down Option",
      body: message,
      needCancel: !isCloseOnly,
      successButtonText: isCloseOnly ? "Ok" : "Proceed",
      preventSuccessPress: true,
      successButtonOnPress: async () => {
        const FloatDownSet = await handleGetFloatDownSet();
        if (FloatDownSet != 1) {
          handleCancelConfirmation({
            head: "Error",
            body:
              "Error occurred in setting up the loan for changing the rate " +
              FloatDownSet +
              ". Please try again or contact support@directcorp.com for additional assistance",
          });
        } else {
          setProcessingStatus(null);
          setRateData(null);
          handleUpdateSearchInfo("isEditMode", true, false);
          setLoanBoardingData(null);
          setLockConfirmationDetails((prevLockConfirmationDetails) => {
            return {
              ...prevLockConfirmationDetails,
              processName: "floatDown",
            };
          });
          handleGetLoanBoardingData(0, { processName: "floatDown" });
          handleSetSessionDataValue();
          setAlertDetails({
            visible: false,
          });
          setModalDetails({
            visible: false,
          });
        }
      },
    });
  };
  const handleGetChangeRate = async (LineId) => {
    return await handleAPI({
      name: "ChangeRate",
      apiName: "RateLockAPI",
      params: { LineId, EmpNum, LoanId: loanId, SessionId },
    }).then((response) => {
      response = JSON.parse(response);
      return response;
    });
  };

  const handleGetFloatDownRates = async () => {
    handleAPI({
      name: "LockRateXMLCreate",
      params: {
        LineId: rateDetails["lineid"],
        EmpNum,
        LoanId: loanId,
      },
    })
      .then((response) => {
        //Come here
        response = new XMLParser().parseFromString(response);
        const loanAmt = RateDetails["LoanAmount"];
        const RateArray = response["children"][4]["children"].map((rate) => {
          let iRate = parseFloat(rate["attributes"]["Rate"]),
            basePoint = parseFloat(rate["attributes"]["Col1"]),
            baseAmt = formatBaseAmount((loanAmt * basePoint) / 100);
          basePoint = parseFloat(
            basePoint.toString().replaceAll("-", "")
          ).toFixed(3);
          basePoint = basePoint < 0 ? "(" + basePoint + "%)" : basePoint + "%";

          return [iRate, basePoint, baseAmt];
        });

        setFloatDownRate(RateArray);
      })
      .catch((err) => console.error("Error form ChangeRateSet ====> ", err));
  };
  const handleGetFloatDownSet = async () => {
    return await handleAPI({
      name: "FloatDownSet",
      apiName: "RateLockAPI",
      params: { LoanId: loanId, EmpNum },
    })
      .then((response) => {
        return response;
      })
      .catch((err) => console.error("Error form LockFloatDownSet ====> ", err));
  };
  const handleGetChangeRateSet = async () => {
    return await handleAPI({
      name: "ChangeRateSet",
      apiName: "RateLockAPI",
      params: { LoanId: loanId },
    })
      .then((response) => {
        return response;
      })
      .catch((err) => console.error("Error form ChangeRateSet ====> ", err));
  };
  const handleSetSessionDataValue = async () => {
    return await handleAPI({
      name: "SetSessionVar",
      params: {
        VarValue: loanId,
        SessionID: SessionId,
        VarName: "RateLock_LoanId",
      },
    })
      .then((response) => {
        return response;
      })
      .catch((err) => console.error("Error form ChangeRateSet ====> ", err));
  };
  const handleExtendRateLock = ({
    DisclosureSigned: iDisclosureSigned,
    AddressValidation: iAddressValidation,
  }) => {
    let {
        allowlockstatus: AllowLockStatus,
        disclosureSigned: DisclosureSigned,
        addresschangedaftervalidation: addressValidation,
      } = lockConfirmationDetails,
      message = "",
      WholesaleIntAccess = 1,
      isCloseOnly = false,
      validatedFlag = 0,
      isAddressValidation = 1;
    //Allowing User to Extend the Lock
    AllowLockStatus = 1;
    addressValidation = iAddressValidation || addressValidation;
    DisclosureSigned = iDisclosureSigned || DisclosureSigned;

    if (AllowLockStatus != 1) {
      if ([4, 5].includes(AllowLockStatus)) {
        message =
          "Interest Rates are currently unavailable. Please check back later for pricing and rate lock options.";
        isCloseOnly = true;
      }
    } else if (AllowLockStatus == 1) {
      if (DisclosureSigned == 0) {
        if (WholesaleIntAccess != 0) {
          validatedFlag = 1;
          message =
            "A lock extension is not allowed until after the initial disclosures are eSigned.";
        } else {
          message =
            "A lock extension is not allowed until after the initial disclosures are eSigned.";
          isCloseOnly = true;
        }
      } else if (addressValidation == 1) {
        if (WholesaleIntAccess != "0") {
          if (validatedFlag != 1) {
            message =
              "A lock extension is not allowed if the property address has changed from the original Rate Lock.";
            isAddressValidation = "0";
          }
        } else {
          message =
            "A lock extension is not allowed if the property address has changed from the original Rate Lock.";
          isCloseOnly = true;
        }
      }

      setProcessingStatus("ExtendLockConfirm");
      setOptionDetails({
        ...optionDetails,
        visible: false,
      });

      if (DisclosureSigned == 1 && addressValidation == 0) {
        setProcessingStatus("ExtendLockRateView");
        handleGetExtendRateView();
      } else if (message) {
        handleCancelConfirmation({
          head: "Confirmation",
          body: message,
          needCancel: !isCloseOnly,
          successButtonText: isCloseOnly ? "Ok" : "Override",
          preventSuccessPress: true,
          successButtonOnPress: () => {
            if (!isCloseOnly) {
              if (DisclosureSigned == 0) {
                setLockConfirmationDetails((prevLockConfirmationDetails) => {
                  return {
                    ...prevLockConfirmationDetails,
                    DisclosureSigned: true,
                    iDisclosureSigned: DisclosureSigned,
                  };
                });
                handleExtendRateLock({ DisclosureSigned: true });
              } else if (isAddressValidation == 0) {
                setLockConfirmationDetails((prevLockConfirmationDetails) => {
                  return {
                    ...prevLockConfirmationDetails,
                    DisclosureSigned: true,
                    iDisclosureSigned: DisclosureSigned,
                  };
                });
                handleExtendRateLock({
                  AddressValidation: isAddressValidation,
                  DisclosureSigned: true,
                });
              }
            }
          },
        });
      }
    }
  };
  useEffect(() => {
    if (extendDetails.length && processingStatus === "ExtendLockRateView") {
      handleGetExtendRateView();
    }
  }, [extendDetails]);
  const handleGetExtendRateView = async () => {
    const headers = ["Select", "Extension Days", "Price", "Expiration Date"];
    handleCancelConfirmation({
      head: `Extend Lock - ${loanId}`,
      body: (
        <>
          <View
            style={[
              { width: "100%" },
              android && {
                minWidth: Dimensions.get("screen")["width"] - 88,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  backgroundColor: "#307ecc",
                  paddingVertical: 10,
                  borderBottomWidth: 1,
                },
              ]}
            >
              {headers.map((header, index) => {
                return (
                  <CustomText
                    key={index}
                    bold
                    style={[
                      styles.cellOne,
                      {
                        color: "#fff",
                      },
                    ]}
                  >
                    {header}
                  </CustomText>
                );
              })}
            </View>
          </View>
          <View
            style={[
              { width: "100%" },
              android && {
                minWidth: Dimensions.get("screen")["width"] - 88,
              },
            ]}
          >
            {extendDetails.map((rowDetails, index) => {
              return (
                <View
                  key={index}
                  style={[
                    styles.tableRow,
                    index % 2 == 0 && { backgroundColor: "#f3f3f3" },
                  ]}
                >
                  <CustomText
                    bold
                    style={[
                      styles.cellOne,
                      {
                        opacity:
                          lockConfirmationDetails["extensionUsed"] == 1 &&
                          rowDetails["TypeOption"] == 1
                            ? 0.3
                            : 1,
                      },
                    ]}
                  >
                    <RadioButtonGroup
                      selected={extendDetails[index]["isSelected"] || null}
                      onSelected={(value) => {
                        if (
                          !(
                            lockConfirmationDetails["extensionUsed"] == 1 &&
                            rowDetails["TypeOption"] == 1
                          )
                        ) {
                          setExtendDetails((prevExtendDetails) => {
                            prevExtendDetails.forEach(
                              (item) => (item["isSelected"] = false)
                            );
                            prevExtendDetails[index]["isSelected"] = true;
                            return [...prevExtendDetails];
                          });
                        }
                      }}
                      radioBackground="#295b9a"
                      size={18}
                    >
                      <RadioButtonItem
                        value={extendDetails[index]["isSelected"] || false}
                        label=""
                      />
                    </RadioButtonGroup>
                  </CustomText>
                  <CustomText bold style={[styles.cellOne]}>
                    {rowDetails["TypeDesc"]}
                  </CustomText>
                  <CustomText bold style={[styles.cellOne]}>
                    {parseFloat(rowDetails["OtherLookUp"] || 0.0).toFixed(4)}
                  </CustomText>
                  <CustomText bold style={[styles.cellOne]}>
                    {rowDetails["Expiration"]}
                  </CustomText>
                </View>
              );
            })}
          </View>
          {lockConfirmationDetails["LockExtensionRestriction"] == 1 ? (
            <CustomText style={{ alignSelf: "flex-end", paddingVertical: 15 }}>
              Lock Extension is restricted on this Second Home,
              Conforming/SuperConforming/HighBalance loan. Please contact
              LockDesk.
            </CustomText>
          ) : (
            <></>
          )}
        </>
      ),
      successButtonText: "Save",
      successButtonOnPress: () => {
        handleInitExtendLock();
        // if (lockConfirmationDetails["LockExtensionRestriction"] == 0) {
        // }
      },
      disableSuccessButton:
        lockConfirmationDetails["LockExtensionRestriction"] == 1,
      needCancel: true,
      preventSuccessPress: true,
    });
  };
  const handleInitExtendLock = () => {
    let selectedOption = extendDetails.filter((item) => item["isSelected"]),
      isCloseOnly = false;
    if (selectedOption.length) {
      selectedOption = selectedOption[0];

      let { TypeOption: LockPeriod, OtherLookUp: LockFee } = selectedOption,
        TotalExtDays =
          parseInt(LockPeriod) +
          parseInt(lockConfirmationDetails["TotalExtendedLock"]),
        message = "";

      if (LockFee == "") {
        message =
          "Atleast one option should be selected for extending the lock rate.";
        isCloseOnly = true;
      }

      if (TotalExtDays > 31) {
        if (lockConfirmationDetails["WholesaleIntAccess"] != "0") {
          message =
            "With this extension, you would exceed the 30-day maximum lock extension timeframe. The total days of all Lock extensions are not allowed to be extended beyond 30 days.";
        } else {
          message =
            "With this extension, you would exceed the 30-day maximum lock extension timeframe. The total days of all Lock extensions are not allowed to be extended beyond 30 days.";
          isCloseOnly = true;
        }
        handleCancelConfirmation({
          head: "Confirmation",
          body: message,
          needCancel: !isCloseOnly,
          successButtonText: isCloseOnly ? "Ok" : "Override",
          successButtonOnPress: () => handleSaveExtendLock(1),
          cancelButtonOnPress: () => {
            handleResetExtendDetails();
            setModalDetails({
              visible: false,
            });
            setAlertDetails({
              visible: false,
            });
            setProcessingStatus(null);
          },
        });
      } else {
        handleSaveExtendLock(0);
      }
    }
  };
  const handleSaveExtendLock = (override) => {
    let selectedOption = extendDetails.filter((item) => item["isSelected"]);
    if (selectedOption.length) {
      selectedOption = selectedOption[0];

      let { TypeOption: LockPeriod, OtherLookUp: LockFee } = selectedOption,
        strXML = `<root lockperiod="${LockPeriod}" lockfee="${LockFee}" overriden="${override}"></root>`,
        body = `Loan will be extended for ${LockPeriod} days at a cost of ${LockFee}. Do you want to proceed?`;

      handleCancelConfirmation({
        head: "Confirmation",
        body,
        needCancel: true,
        successButtonText: "Proceed",
        preventSuccessPress: true,
        successButtonOnPress: () => {
          setProcessingStatus("savingRateExtendLock");
          setAlertDetails({ visible: false });
          handleAPI({
            name: "SaveLockRateExtendLock",
            params: {
              LoanId: loanId,
              EmpNum,
              strXML,
            },
          })
            .then((response) => {
              setProcessingStatus("refreshingLockExpiryDate");
              handleGetLockExpiryDate(0);
            })
            .catch((e) => {
              console.error("Error form ====> SaveLockRateExtendLock", e);
            });
        },
      });
    }
  };
  const handleGetLockExpiryDate = (LockTimer) => {
    const prevLockDate = formatDate(lockConfirmationDetails["complockexpire"]);

    handleAPI({
      name: "GetLockExpiryDate",
      params: {
        LoanId: loanId,
      },
    })
      .then((response) => {
        if (
          response !== "" &&
          response !== "Monday, January 1, 1900" &&
          prevLockDate != response
        ) {
          setLockConfirmationDetails((prevLockConfirmationDetails) => {
            return {
              ...{
                ...prevLockConfirmationDetails,
                lockExpDate: response,
              },
            };
          });
          setProcessingStatus(null);
        } else if (LockTimer <= 10) {
          setTimeout(function () {
            handleGetLockExpiryDate(LockTimer++);
          }, 1000);
        }
      })
      .catch((e) => console.error("Error From GetLockExpiryDate ====> ", e));
  };
  const handleGetRateLockDetails = (Polling) => {
    handleAPI({
      name: "DoLockRateProcess",
      apiName: "RateLockAPI",
      params: {
        LineID: 0,
        EmpNum,
        BaseRate: "",
        BasePoints: "",
        ParPeriod: "",
        LoanId: loanId,
        RateSheetId: 0,
        LockType: "",
        SessionID: SessionId,
        FinalPoints: "",
        ProcessType: 2,
        NeedJson: 1,
      },
    }).then((response) => {
      try {
        response = JSON.parse(response)["DataOut"];

        if (Object.keys(response?.[2]).length == 0 && Polling < 4) {
          setTimeout(() => {
            handleGetRateLockDetails(Polling + 1);
          }, 500);
        } else if (Polling > 4) {
          console.log("Polling count DoLockRateProcess (Get) ==>", Polling);
        } else {
          handleLoanApr();

          handleGetMonthlyPayment();
          let {
            showchangeintrate,
            allowlockstatus,
            funded,
            settled,
            withdrawn,
            showrelock,
            finaluw,
            closed,
            ClosingDocsSent,
            lockaccess,
          } = response?.[1]?.["LockConfObjects"]?.[0];
          setExtendDetails(response[8]["ExtendOptions"]);
          const { comprateadj: rate } = response?.[1]?.["LockConfObjects"]?.[0];

          handleGetLineIdLockPeriod({ rate });
          let showLockExtend = 0,
            showLockBtn = 0,
            showChangeRate = 0,
            showCancelLock = 0,
            showFloatDown = 0,
            showRelock = 0;

          if (
            showchangeintrate == "1" &&
            (allowlockstatus == "1" || allowlockstatus == "0") &&
            funded == "0" &&
            settled == "0" &&
            withdrawn == 0
          )
            showLockExtend = 1;
          if (showrelock == "1" && settled == "0" && finaluw == "1")
            showLockBtn = 1;
          if (
            showchangeintrate == "1" &&
            funded == "0" &&
            settled == "0" &&
            finaluw == "0"
          )
            showChangeRate = 1;
          if (funded == "0" && settled == "0") showCancelLock = 1;
          if (
            showchangeintrate == "1" &&
            (allowlockstatus == "1" || allowlockstatus == "0") &&
            funded == "0" &&
            settled == "0" &&
            withdrawn == "0" &&
            closed == "0"
          )
            showFloatDown = 1;
          if (
            showchangeintrate == "0" &&
            lockaccess == "1" &&
            funded == "0" &&
            settled == "0" &&
            ClosingDocsSent == "0" &&
            withdrawn == 0
          )
            showRelock = 1;

          setLockConfirmationDetails((prevLockConfirmationDetails) => {
            const iLockConfirmationDetails = {
              ...prevLockConfirmationDetails,
              ...response?.[0]?.["RootObjects"]?.[0],
              ...response?.[1]?.["LockConfObjects"]?.[0],
              ...response?.[9]?.["InvestorInfo"]?.[0],
              showLockExtend,
              showLockBtn,
              showChangeRate,
              showCancelLock,
              showFloatDown,
              showRelock,
              APR: undefined,
            };
            return iLockConfirmationDetails;
          });

          handleGetLeftNavStatus(true, true);
        }
      } catch (error) {
        console.log("DoLockRateProcess Error ==>", error);
      }
    });
  };

  const handleUpdateSearchInfo = (key, value, isClear = true) => {
    if (isClear) {
      processingStatus && setProcessingStatus(null);
      setRateData([]);
    }

    setSearchInfo((prevSearchInfo) => ({ ...prevSearchInfo, [key]: value }));
  };
  const handleFilterValidation = () => {
    let { loanType, term, amortType, lienPosition, lockPeriod } = searchInfo;

    return !(loanType && term && amortType && lienPosition && lockPeriod);
  };
  const handleConstructInputs = (params) => {
    try {
      const {
        LoanProgNum = "",
        loanBoardingData: iLoanBoardingData = loanBoardingData,
      } = params || {};

      let { BorrInfo } = iLoanBoardingData["DataOut"][2],
        { PropertyInfo } = iLoanBoardingData["DataOut"][3],
        { LoanParamInfo } = iLoanBoardingData["DataOut"][4],
        { LoanSearchInfo } = iLoanBoardingData["DataOut"][5],
        { LoanOfficer } = iLoanBoardingData["DataOut"][8],
        { RootObjects } = iLoanBoardingData["DataOut"][0],
        { EmpNumber: LoanOfficerId } = LoanOfficer[0],
        { CompNum, compname, EmpRights } = RootObjects[0];

      BorrInfo.forEach((info, index) => {
        BorrInfo[index] = {
          ...info,
          firstTimeHomeBuyer: info.firstTimeHomeBuyer == "No" ? 0 : 1,
        };
      });

      const { amortType, loanType, term, lienPosition, lockPeriod } =
        searchInfo;
      if (!(params && LoanProgNum)) {
        LoanSearchInfo[0] = {
          ...LoanSearchInfo[0],
          AmortType: Number(amortType),
          LoanType: Number(loanType),
          Term: Number(term),
          LockPeriod: Number(lockPeriod),
        };
      }
      let QualifyingFICO = fnFindMinFICO(BorrInfo),
        iLoanSearchInfo = [{}];
      [
        "DesiredRate",
        "ddlRateMethod",
        "ChargeRebate",
        "NearestCharge",
        "LockPeriod",
        "FeesinRate",
        "RequestEscrow",
        "EnergyEffMort",
        "PropertylistedonMLS",
        "QualifyingFICO",
        "LoanProgNum",
        "NonProfitGiftFund",
        "LenderBorrowerPaid",
        "LoanType",
        "AmortType",
        "Term",
        "AmortizeTime",
        "ARMIndex",
        "FixedPeriod",
        "MortIns",
        "FHADate",
        "ExistingGovtLoan",
        "HudREPO",
        "DisplayLenderComp",
        "CompensationType",
        "LawEnforceGrant",
        "SearchNoPPP",
        "LendersToSearch",
        "TBD",
        "MortInsPremium",
      ].forEach((key) => {
        iLoanSearchInfo[0][key] = LoanSearchInfo[0][key];
      });

      iLoanSearchInfo[0]["CompensationType"] = 2;
      iLoanSearchInfo[0]["HudREPO"] = "0";
      iLoanSearchInfo[0]["LendersToSearch"] = "";
      iLoanSearchInfo[0]["QualifyingFICO"] = QualifyingFICO;
      iLoanSearchInfo[0]["SearchNoPPP"] = iLoanSearchInfo[0]["SearchNoPPP"]
        .SearchNoPPP
        ? 1
        : 0;

      iLoanSearchInfo[0]["LoanProgNum"] = LoanProgNum || "";

      if (!(params && LoanProgNum)) {
        PropertyInfo[0] = {
          ...PropertyInfo[0],
          LienPosition: Number(lienPosition) || 1,
        };
      }
      LoanParamInfo[0] = {
        ...LoanParamInfo[0],
        IsSelfEmployed: LoanParamInfo[0].IsSelfEmployed ? 1 : 0,
        LoanOfficer: LoanOfficerId,
      };
      delete LoanParamInfo[0].ExistingLiens;
      let InputData = {
        DataIn: [
          {
            RootObjects: [
              {
                ViewType: "CV",
                SessionId: SessionId,
                FromNewRateLock: 1,
                IISSessionId: "kk0htdbpzh3gg1kw5gprve4p",
                LoanID: loanId,
                EmpNum,
                CompNum,
                compname: compname.replace("&", "~amp~"),
                EmpRights,
                BorrCount: BorrInfo.length || 0,
                Prequal: 0,
              },
            ],
          },
          {
            BorrInfo,
          },
          {
            PropertyInfo,
          },
          {
            LoanParamInfo,
          },
          {
            LoanSearchInfo: iLoanSearchInfo,
          },
        ],
      };

      return InputData;
    } catch (error) {
      //   setModalOpen({
      //     ...modalOpen,
      //     RateSheetRunWarning: true,
      //     Msg: "  Error while searching loan products, Please check the inputs and Try again.         ",
      //   });
    }
  };

  const handleGetRateAvailability = async ({
    LineId,
    RateSheetId,
    BaseRate,
    BasePoints,
    ParPeriod,
  }) => {
    let strXML = await handleLockRateValidation(
        LineId,
        EmpNum,
        loanId,
        RateSheetId
      ),
      iPriceAvailability = null;
    strXML = new XMLParser().parseFromString(strXML);
    let { Status } = strXML["attributes"],
      { value } = strXML["children"][0];

    if (Status == 1) {
      let iStrXML = await handleLockRateValidation_DBChecks(
        LineId,
        EmpNum,
        loanId,
        RateSheetId,
        0,
        SessionId,
        1,
        BaseRate,
        BasePoints,
        ParPeriod
      );
      iStrXML = new XMLParser().parseFromString(iStrXML);

      Status = iStrXML["children"][1]["attributes"]["Status"];
      value = iStrXML["children"][1]["children"][0]["value"];

      if (Status == 0) {
        if (value) {
          iPriceAvailability = value.includes("price change has occurred")
            ? "priceChanged"
            : value.includes("expired")
            ? "ratesExpired"
            : value;
        } else {
          // iPriceAvailability =
          //   "Error occurred in locking the rate and selecting the loan program. Please try again or contact support@directcorp.com for additional assistance.";
        }
      }
    } else {
      if (value.includes("expired")) {
        iPriceAvailability = "ratesExpired";
      } else {
        handleCancelConfirmation({
          head: !value ? "Error" : "",
          body:
            value ||
            "Error occurred in locking the loan program. Please try again or contact support@directcorp.com for additional assistance",
        });
      }
    }
    return iPriceAvailability;
  };
  const fnFindMinFICO = (data) => {
    let minFicoScore = data[0]["FICO"];
    data.forEach(({ FICO }) => {
      const ficoScore = parseInt(FICO);
      minFicoScore = ficoScore < minFicoScore ? ficoScore : minFicoScore;
    });

    return minFicoScore;
  };
  const handleValidateSSN = () => {
    const { BorrInfo } = loanBoardingData["DataOut"][2];
    return BorrInfo.filter(({ SSN }) => testSSN(SSN)).length > 0;
  };
  const handleLockRateValidation = async (
    LineID,
    EmpNum,
    LoanId,
    RateSheetId
  ) => {
    return await handleAPI({
      name: "LockRateValidation",
      params: { LineID, EmpNum, LoanId, RateSheetId },
      apiName: "RateLockAPI",
    }).then((response) => {
      return response;
    });
  };
  const handleLockRate = async (form) => {
    if (form === "AddressInfoSection") {
      if (handleValidateSSN()) {
        setProcessingStatus("SSNDetails");
        return;
      }
    }
    setProcessingStatus("rateSelect&Lock");
    if (form) {
      await handleSaveLoanBoardingData();
    }
    const {
      LineId,
      RateSheetId,
      Rate: BaseRate,
      LockPeriods: ParPeriod,
      BasePoints,
      points: FinalPoints,
    } = selectedRate;
    if (["changeRate", "floatDown"].includes(processName)) {
      handleDoLockRateProcess(
        LineId,
        EmpNum,
        BaseRate,
        BasePoints,
        ParPeriod,
        loanId,
        RateSheetId,
        "",
        SessionId,
        FinalPoints,
        1,
        1
      );
      return;
    }
    let strXML = await handleLockRateValidation(
      LineId,
      EmpNum,
      loanId,
      RateSheetId
    );
    strXML = new XMLParser().parseFromString(strXML);
    let { Status } = strXML["attributes"],
      { value } = strXML["children"][0];

    if (Status == 1) {
      let iStrXML = await handleLockRateValidation_DBChecks(
        LineId,
        EmpNum,
        loanId,
        RateSheetId,
        0,
        SessionId,
        1,
        BaseRate,
        BasePoints,
        ParPeriod
      );
      iStrXML = new XMLParser().parseFromString(iStrXML);
      let { WarnStatus } = iStrXML["children"][2]["attributes"];
      Status = iStrXML["children"][1]["attributes"]["Status"];
      value = iStrXML["children"][1]["children"][0]["value"];
      if (Status == 0) {
        let body = "",
          successButtonText = "Ok",
          successButtonOnPress = () => {};
        if (value != "") {
          if (value.includes("price change has occurred")) {
            body =
              "Pricing has changed since your last search. Click Refresh to see current pricing.";
            successButtonText = "Refresh";
            successButtonOnPress = () => {
              setPriceAvailability(priceChanged);
            };
          } else {
            body = value;
          }
        } else
          body =
            "Error occurred in locking the rate and selecting the loan program. Please try again or contact support@directcorp.com for additional assistance";

        handleCancelConfirmation({
          head: "",
          body,
          successButtonText,
          successButtonOnPress,
        });
      } else {
        if (WarnStatus == 1) {
          let Msg = iStrXML["children"][2]["children"][0]["value"];

          handleCancelConfirmation({
            head: "Confirmation",
            body: (
              <CustomText>
                {Msg.split("~").map((e, index) => (
                  <CustomText key={index}>{e}</CustomText>
                ))}
              </CustomText>
            ),
            needCancel: true,
            successButtonText: "Proceed",
          });
        }
        if (WarnStatus == 99) {
          // if all validations are good - then will call the Actual Lock Rate process
          handleDoLockRateProcess(
            LineId,
            EmpNum,
            BaseRate,
            BasePoints,
            ParPeriod,
            loanId,
            RateSheetId,
            "",
            SessionId,
            FinalPoints,
            1,
            1
          );
        }
      }
    } else {
      handleCancelConfirmation({
        head: "",
        body:
          value ||
          "Error occurred in locking the loan program. Please try again or contact support@directcorp.com for additional assistance",
      });
    }
  };
  const handleDoLockRateProcess = (
    LineId,
    EmpNum,
    BaseRate,
    BasePoints,
    ParPeriod,
    LoanId,
    RateSheetId,
    LockType,
    SessionId,
    FinalPoints,
    ProcessType,
    NeedJson
  ) => {
    if (FinalPoints.includes("(") != -1) {
      FinalPoints = FinalPoints.replace("(", "-").replace(")", "");
    }
    let obj = {
      LineID: LineId,
      EmpNum,
      BaseRate,
      BasePoints,
      ParPeriod,
      LoanId,
      RateSheetId,
      LockType,
      SessionID: SessionId,
      FinalPoints,
      ProcessType,
      NeedJson,
    };

    handleAPI({
      name: "DoLockRateProcess",
      params: obj,
      apiName: "RateLockAPI",
    }).then((response) => {
      setLockConfirmationDetails({
        lockExpDate: null,
        isLocked: true,
        processName,
      });
      setModalDetails({
        visible: false,
      });
      console.log("DoLockRateProcess response ==>", response);
      setTimeout(() => {
        handleCheckRateLockPool(0);
      }, 1000);
      if (!web || isSmallScreen) handlePricingBasedOnDefaultSettings();
    });
  };
  const handleCheckRateLockPool = async (pollingCount = 0) => {
    console.log("handleCheckRateLockPool ==>>", pollingCount);
    const isLocked = await IsLockedLoan(loanId);
    if (isLocked == 1) {
      handleGetLoanBoardingData(isLocked);
      setProcessingStatus(null);
      setModalDetails({
        visible: false,
      });
      setAlertDetails({ visible: false });
    } else if (pollingCount < 10) {
      setTimeout(() => {
        handleCheckRateLockPool(pollingCount + 1);
      }, 1500);
    } else {
      handleGetLoanBoardingData(isLocked);
    }
  };
  const handleLockRateValidation_DBChecks = async (
    LineId,
    EmpNum,
    LoanId,
    RateSheetId,
    ChangeLnPrgm,
    SessionId,
    flag,
    BaseRate,
    BasePoints,
    ParPeriod
  ) => {
    let obj = {
      LineID: LineId,
      EmpNum,
      LoanId,
      RateSheetId,
      ChangeLnPrgm,
      Sessionid: SessionId,
      flag,
      BaseRate,
      BasePoints,
      ParPeriod,
    };
    return await handleAPI({
      name: "LockRateValidation_DBChecks",
      params: obj,
      apiName: "RateLockAPI",
    }).then((response) => {
      return response;
    });
  };
  const handleSelectRate = async () => {
    handleSaveLoanBoardingData();

    const {
      LineId: LineID,
      Rate: BaseRate,
      BasePoints,
      points: FinalPoints,
      LockPeriods: ParPeriod,
      RateSheetId,
    } = selectedRate;

    handleAPI({
      name: "RateLockOption_SelectOnly",
      apiName: "RateLockAPI",
      params: {
        LineID,
        EmpNum,
        BaseRate,
        BasePoints,
        ParPeriod,
        LoanId: loanId,
        RateSheetId,
        LockType: "",
        SessionID: SessionId,
        FinalPoints,
      },
    }).then((response) => {
      setLockConfirmationDetails((prevLockConfirmationDetails) => {
        prevLockConfirmationDetails["isFloated"] = true;
        prevLockConfirmationDetails["isFloatedGrettings"] = true;
        return { ...prevLockConfirmationDetails };
      });
      setModalDetails({
        visible: false,
      });
      setProcessingStatus(null);
      if (!web || isSmallScreen) handlePricingBasedOnDefaultSettings();
    });
  };
  const handlePricingBasedOnDefaultSettings = () => {
    try {
      handleAPI({
        name: "PricingBasedOnDefaultSettings",
        params: {
          LoanId: loanId,
          SessionId,
        },
      })
        .then(async (response) => {
          console.log(
            "response form PricingBasedOnDefaultSettings ===> ",
            response
          );
          // await Alert.alert(
          //   "Info",
          //   "E-sign package generation has been initiated, and you will be navigated to the Document Upload page"
          // );
          if (response == 1) handleGetBorrowerUrl({ landOn: "eSign" });
        })
        .catch((error) =>
          console.error(
            "Error from PricingBasedOnDefaultSettings ====> ",
            error
          )
        );
    } catch (error) {}
  };
  const handleCancelConfirmation = ({
    head = "",
    body = "",
    needCancel = false,
    needSuccessButton = true,
    successButtonText = "Ok",
    cancelButtonOnPress = null,
    successButtonOnPress = () => {
      setProcessingStatus(null);
    },
    disableSuccessButton = false,
    preventSuccessPress = false,
  }) => {
    setModalDetails({ visible: false });
    setAlertDetails({
      visible: true,
      head,
      body,
      needCancel,
      successButtonText,
      successButtonOnPress,
      disableSuccessButton,
      cancelButtonOnPress,
      preventSuccessPress,
      needSuccessButton,
    });
  };
  const handleLockRateProceed = () => {
    const { PropertyInfo } = loanBoardingData["DataOut"][3],
      { SubjectAddress = "", SubjectZip = "" } = PropertyInfo[0];
    if (SubjectAddress && SubjectZip) {
      if (handleValidateSSN()) {
        setProcessingStatus("SSNDetails");
      } else {
        setProcessingStatus("rateSelect&Lock");
        handleLockRate();
      }
    } else {
      setProcessingStatus("addressInfoSection");
      setModalDetails((prevModalDetails) => {
        return { ...prevModalDetails, visible: true };
      });
    }
  };

  const handleSearchLoanProducts = async (params) => {
    let res = "";

    let InputData = handleConstructInputs(params);

    __DEV__ && console.log(" handleLoanProductsSearch Input ===>>", InputData);

    handleAPI({
      name: "DOSLPTasks_",
      apiName: "RateLockAPI",
      params: {},
      requestOptions: {
        method: "POST",
        redirect: "follow",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          InputJSON: JSON.stringify(InputData || ""),
        }),
      },
    }).then((response) => {
      if (!response) return;
      console.log(
        "============================ Got the Run Id=================="
      );
      response = JSON.parse(response);
      let { RetStatus, Error, LatestRun } =
        response["DataOut"][0]["RootObjects"][0];
      // console.log({ RetStatus });

      if (RetStatus == 99) {
        setProcessingStatus("searchingProducts");
        setTimeout(() => {
          handleGetLoanProducts(RetStatus, LatestRun, 0, res, params); //16009895 ,16018701 , 16034653,16040931 - 66
        }, 500);

        // try {
        //   handleLogDWCallToActionEventParent(
        //     "Search for Loan Products",
        //     contextDetails["parentQueryString"]["email"],
        //     isMobileWeb,
        //     GlobleValue["LO"]
        //   );
        // } catch (error) {
        //   console.error(
        //     "Error in handleLogDWCallToActionEventParent ==>",
        //     error
        //   );
        // }
        // Interest Rates are Temporarily Unavailable
      } else if (RetStatus == -2) {
        handleCancelConfirmation({
          head: "Error",
          body: Error,
        });
        setProcessingStatus(null);
        handleGetLoanProducts("", 16018701, 0, res, params); // when error occurs
      } else if (RetStatus == -5 || RetStatus == -1) {
        handleCancelConfirmation({
          head: "Interest Rates are Temporarily Unavailable",
          body:
            RetStatus == -5
              ? "Interest Rates are currently being updated. This typically takes about 10 minutes. Please try again in a few minutes"
              : Error,
        });
        setProcessingStatus(null);
        // setModalOpen({ ...modalOpen, RateSheetRunWarning: true, Msg: Error });
        // handleStatus({ Searching: false });
      }

      __DEV__ && console.log("DOSLPTasks ==>>", response);
    });
  };
  const handleGetLoanProducts = async (
    Status,
    LatestRun,
    pollingCount,
    res,
    params
  ) => {
    console.log("pollingCount ==>>", pollingCount);
    // let EmpNum = await handleGetSessionData(
    //   contextDetails["queryString"]["SessionId"],
    //   "empnum"
    // );
    // if (EmpNum == "Output") {
    //   setModalOpen({
    //     ...modalOpen,
    //     RateSheetRunWarning: true,
    //     Msg: "      Your Session is InActive!!!       ",
    //   });
    //   return;
    // }
    let obj = {
      DataIn: [
        {
          RootObjects: [
            {
              LoanId: loanId,
              EmpNum,
              Run: LatestRun || 0,
              ExcludeLines: "",
              IU_PollingCounter: pollingCount,
              UserType: "E" || "C",
              IsSearchedLoan: "0",
              blCompressJson: "0",
            },
          ],
        },
      ],
    };

    handleAPI({
      name: "Get_LoanProgramIU",
      // apiName: "RateLockAPI",
      params: {
        OutFlag: 1,
        Inputjson: JSON.stringify(obj),
        processFlag: params ? 1 : 0,
      },
    }).then(async (response) => {
      try {
        if (response.includes("Unable to cast object")) {
          if (pollingCount < 8) {
            // Looping till the program return
            setTimeout(() => {
              handleGetLoanProducts(
                "",
                LatestRun,
                pollingCount + 1,
                res,
                params
              );
            }, 500);
          } else {
            handleCancelConfirmation({
              head: "Error",
              body: "Error occurred in showing loan programs.",
            });

            handlePricingError({
              EmpNum,
              Loan: loanId,
              ErrorMessage: JSON.stringify(response),
              type: 2,
            });
            return;
          }
        } else {
          // debugger;
          response = JSON.parse(response);
          __DEV__ && console.log("response", response);

          let FewLinesErrored =
            response?.["DataOut"]?.[0]?.["RootObjects"]?.[0]?.[
              "FewLinesErrored"
            ] || "0";

          if (FewLinesErrored == 1) {
            handleCancelConfirmation({
              head: "Error",
              body: "Error occurred in showing loan programs.",
            });

            handlePricingError({
              EmpNum: EmpNum,
              Loan: loanId,
              ErrorMessage: JSON.stringify(
                response?.["DataOut"]?.[0]?.["RootObjects"]?.[0] || "{}"
              ),
              type: 1,
            });
            return;
          }

          let iRateData = [...response["DataOut"]],
            loanProgramsList = {};

          const loanProgramOrder = iRateData.pop();
          iRateData.shift();

          __DEV__ && console.log(loanProgramOrder);

          if (loanProgramOrder["LoanProgramsList"]) {
            iRateData = orderLoanProgram(
              iRateData,
              loanProgramOrder["LoanProgramsList"]?.map(
                ({ LPA_CommonData }) => LPA_CommonData
              ),
              loanProgramOrder["LoanProgramsList"]?.map(({ LineID }) => LineID)
            );

            loanProgramsList = loanProgramOrder["LoanProgramsList"].reduce(
              (acc, { LineID, CommonProgramName }) => {
                acc[LineID] = CommonProgramName;
                return acc;
              },
              {}
            );

            if (Object.keys(loanProgramsList).length) {
              iRateData = replaceLoanProductName(
                iRateData,
                loanProgramsList,
                "LineId"
              );
            }
            iRateData[0]["isExpand"] = true;

            let {
                LineId: lineId,
                LockDays,
                Name: programName,
                InterestRate,
                RateSheetId,
              } = Object.values(iRateData[0])[0][1]["LoanProgramDetails"][0],
              { LockPeriod = [] } = Object.values(iRateData[0])[0][4],
              { Addons = [] } = Object.values(iRateData[0])[0][6],
              { LoanData = [] } = Object.values(iRateData[0])[0][2],
              { LenderCompAmt = 0, LoanAmt = 0 } = LoanData[0];

            let LockPeriodArray = LockPeriod.filter(
              ({ LockExpDate }) => LockExpDate == LockDays
            );
            if (LockPeriodArray.length == 0) {
              LockPeriodArray = LockPeriod.filter(
                ({ LockPeriodID }) => LockPeriodID == 4
              );
            }
            // const { LockPeriods, COlID, LockPeriodID } =
            //     LockPeriodArray[0] || {},
            //   { [COlID]: BasePoints } =
            //     Object.values(iRateData[0])[0][5]["RateData"].filter(
            //       ({ Rate }) => Rate == InterestRate
            //     )?.[0] || {};
            let LenderCompPoints =
              (parseFloat(LenderCompAmt) / parseFloat(cleanValue(LoanAmt))) *
              100;

            const totalAddons = Addons.reduce((acc, { Disc }) => {
              return acc + parseFloat(Disc);
            }, 0);
            const { LockPeriods, COlID, LockPeriodID } =
                LockPeriodArray[0] || {},
              selectedRateObject =
                Object.values(iRateData[0])[0][5]["RateData"].filter(
                  ({ Rate }) => Rate == InterestRate
                )?.[0] || {},
              { RateSheetName, LnProgActiveId, MonthlyPayment } =
                selectedRateObject,
              { [COlID]: BasePoints } = selectedRateObject;

            if (
              !["changeRate", "floatDown"].includes(processName)
              // && !__DEV__
            ) {
              const iPriceAvailability = await handleGetRateAvailability({
                LineId: lineId,
                RateSheetId,
                BaseRate: InterestRate,
                BasePoints: BasePoints,
                ParPeriod: LockPeriods,
              });
              setPriceAvailability(iPriceAvailability);
            }
            setRateData(iRateData);
            handleGetAPR(
              lineId,
              Number(cleanValue(InterestRate)),
              LockPeriods,
              true
            );
            handleGetCashToClose(
              lineId,
              LockPeriodID,
              true,
              Number(cleanValue(InterestRate))
            );
            setSelectedRate({
              RateSheetName,
              Rate: Number(cleanValue(InterestRate)),
              LineId: lineId,
              LnProgActiveId,
              points: getPoints(
                parseFloat(BasePoints) + totalAddons + LenderCompPoints
              ).toString(),
              MonthlyPayment,
              // cashtoclose
              LockPeriod,
              BasePoints: parseFloat(BasePoints),
              RateSheetId,
              programName,
            });
            if (iRateData.length === 0) {
              handleUpdateSearchInfo("isEditMode", true, false);
            }
            handleUpdateSearchInfo("isEditMode", false, false);
          } else {
            setRateData([]);
            handleUpdateSearchInfo("isEditMode", true, false);
            const { NumLoanPrograms = 0, NumLineIds = 0 } =
              response?.["DataOut"]?.[0]?.["RootObjects"]?.[0];

            handlePricingError({
              EmpNum: EmpNum,
              Loan: loanId,
              ErrorMessage: JSON.stringify({
                Run: LatestRun,
                FewLinesErrored: "1",
                NumLoanPrograms,
                NumLineIds,
              }),
              type: 1,
            });
          }

          setProcessingStatus("searchFinished");
          __DEV__ && console.log("Get_LoanProgramIU == >", response);
        }
      } catch (error) {
        if (pollingCount < 5) {
          // Looping till the program return
          setTimeout(() => {
            handleGetLoanProducts("", LatestRun, pollingCount + 1, res);
          }, 500);
        }
        console.log(
          `Error while parsing the loan programs at ${pollingCount} polling`
        );
        console.error("Error while parsing the loan programs ===> ", error);
      }
    });
  };
  const handleLayout = () => {
    // setTimeout(() => {
    //   targetRef?.current?.measureLayout(
    //     scrollViewRef.current,
    //     (x, y, width, height) => {
    //       const centerY =
    //         y - scrollViewRef.current.clientHeight / 2 + height / 2;
    //       if (centerY < 100) return;
    //       scrollViewRef.current.scrollTo({
    //         y: centerY,
    //         animated: true,
    //         behavior: "smooth",
    //       });
    //     },
    //     (error) => {
    //       console.error(error);
    //     }
    //   );
    // }, 100);
  };
  const orderLoanProgram = (array, order, lineIdArr) => {
    let neArr = array.filter((a) => {
      return lineIdArr.includes(Number(Object.keys(a)[0].split("_")[1]));
    });
    neArr = neArr.sort((a, b) => {
      const aValue =
        Object.values(a)[0][1].LoanProgramDetails[0].LPA_CommonData;
      const bValue =
        Object.values(b)[0][1].LoanProgramDetails[0].LPA_CommonData;
      return order.indexOf(aValue) - order.indexOf(bValue);
    });
    return neArr;
  };
  const replaceLoanProductName = (array, loanProductName, key) => {
    return array.map((item) => {
      let name =
        loanProductName[
          item[Object.keys(item)[0]][1].LoanProgramDetails[0][key]
        ];
      if (name) {
        name = name.replace("DirectPro", "");
        item[Object.keys(item)[0]][1].LoanProgramDetails[0].Name = name;
      }

      return item;
    });
  };
  const handleGetRowColor = ({ index, LineId, Rate, iIndex }) => {
    const { LineId: iLineId = 0, Rate: iRate = 0 } = selectedRate;
    if (Number(LineId) === Number(iLineId) && Number(Rate) === Number(iRate)) {
      return { backgroundColor: "#BCD4E3", active: true };
    }

    if (iIndex % 2 > 0) {
      return { backgroundColor: "#F6F9FC", active: false };
    } else {
      return { backgroundColor: "#fff", active: false };
    }
  };

  useEffect(() => {
    try {
      if ((rateData || []).length > 0) {
        rateData?.forEach((itemArray, index) => {
          const { LineId, LockDays } =
              Object.values(itemArray)[0][1]["LoanProgramDetails"][0],
            { LockPeriod = [] } = Object.values(itemArray)[0][4],
            isExpand = rateData[index]["isExpand"] || false,
            { RateData: rowData = [] } = Object.values(itemArray)[0][5];

          const { LockPeriods, LockPeriodID } =
            LockPeriod["length"] > 1
              ? LockPeriod.filter(
                  ({ LockExpDate }) => LockExpDate == LockDays
                )?.[0] || {}
              : LockPeriod[0] || {};

          if (isExpand) {
            if (!cashToCloseDetails?.[LineId])
              handleGetCashToClose(LineId, LockPeriodID);
            rowData.forEach(({ Rate }) => {
              Rate = cleanValue(Rate);

              const { APR = "Calculating" } =
                aprRateState?.[LineId]?.[Rate] || {};

              if (
                APR == "Calculating"
                // && priceAvailability !== "ratesExpired"
              ) {
                handleGetAPR(LineId, Rate, LockPeriods);
              }
            });
          }
        });
      }
    } catch (error) {
      console.error("Error in useEffect (rateData) ===> ", error);
    }
  }, [rateData]);
  const handleResetExtendDetails = () => {
    setLockConfirmationDetails((prevLockConfirmationDetails) => {
      let disclosureSigned =
        prevLockConfirmationDetails["iDisclosureSigned"] || false;
      delete prevLockConfirmationDetails["iDisclosureSigned"];
      return {
        ...prevLockConfirmationDetails,
        DisclosureSigned: disclosureSigned,
      };
    });
  };
  const handleSaveLoanBoardingData = async () => {
    const InputData = handleConstructInputs(),
      body = { LoanID: loanId, SaveJson: JSON.stringify(InputData || "") };

    let response = await handleAPI({
      name: "LoanBoardingSave_",
      apiName: "RateLockAPI",
      params: {},
      requestOptions: {
        method: "POST",
        redirect: "follow",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    }).then((response) => {
      return response;
    });

    __DEV__ && console.log("handleSaveLoanBoardingData ==>>", response);
  };
  const handleCancelLock = async () => {
    let { cancelLockReason } = lockConfirmationDetails;

    let Response = await handleGetJournalPost(loanId);
    let Result = "";
    Response = Response.split("~");
    if (Response[0] == "") {
      //Do Nothing
    } else if (Response[0] == "0" || Response[2] != "1") {
      let XmlDataIn =
        '<param Name="LoanID">' +
        loanId +
        '</param><param Name="ProcessId">1</param><param Name="Posting_Action">0</param><param Name="EmpNum">' +
        EmpNum +
        "</param>";
      Result = await handleUnPostJournal(XmlDataIn);
    }

    Result = await SaveLockRateCancelReason(
      loanId,
      EmpNum,
      cancelLockReason,
      "BrokerCancel"
    );
    if (Result != 1) {
      handleCancelConfirmation({
        head: "Error",
        body: "Error occurred in cancelling the lock.",
      });
    } else {
      handleGetLeftNavStatus(true);
    }
  };
  const handleGetCancelLock = () => {
    handleCancelConfirmation({
      ...{
        head: `Cancel Lock - ${loanId}`,
        body: "cancelLockReason",
        needCancel: true,
        successButtonText: "Cancel Lock",
        cancelButtonOnPress: () => {
          setLockConfirmationDetails((prevLockConfirmationDetails) => {
            delete prevLockConfirmationDetails["cancelLockReason"];
            delete prevLockConfirmationDetails["isCancelLock"];
            delete prevLockConfirmationDetails["isFloated"];
            return {
              ...prevLockConfirmationDetails,
            };
          });
          setAlertDetails({
            visible: false,
          });
        },
        preventSuccessPress: true,
        successButtonOnPress: () => {
          setLockConfirmationDetails({
            lockExpDate: null,
            isLocked: 0,
          });
          setAlertDetails({
            visible: false,
          });
          setRateData(null);
          handleUpdateSearchInfo("isEditMode", true, false);
          setLoanBoardingData(null);
          handleGetLoanBoardingData(0);
          handleCancelLock();
        },
        disableSuccessButton: !lockConfirmationDetails["cancelLockReason"],
      },
    });
  };
  useEffect(() => {
    if (lockConfirmationDetails["isCancelLock"]) {
      handleGetCancelLock();
    }
  }, [lockConfirmationDetails["cancelLockReason"]]);

  const handleGetAPR = async (
    lineid,
    IntRate,
    LockPeriod,
    isUpdateSelectedRate
  ) => {
    if (!Number(lineid) || !IntRate || !LockPeriod) return "0.0000%";
    try {
      handleAPI({
        name: "GetAPRValue",
        apiName: "RateLockAPI",
        params: { lineid, IntRate },
      }).then((response) => {
        response = response.split("~")[1];
        response = JSON.parse(response);
        response = response["DataOut"] && response["DataOut"][0]["APRData"][0];
        let { APR } = response,
          { count = 0 } = aprRateState?.[lineid]?.[IntRate] || {};

        if (APR == "0.0000%" && count < 6) {
          count = count + 1;
          setAprRateState((prevAprRate) => {
            if (!prevAprRate[lineid]) prevAprRate[lineid] = {};
            if (!prevAprRate[lineid][IntRate])
              prevAprRate[lineid][IntRate] = {};
            prevAprRate[lineid][IntRate]["count"] = count;
            return { ...prevAprRate };
          });
          handleGetARM(lineid, IntRate, LockPeriod);
        } else {
          setAprRateState((prevAprRate) => {
            if (!prevAprRate[lineid]) prevAprRate[lineid] = {};
            if (!prevAprRate[lineid][IntRate])
              prevAprRate[lineid][IntRate] = {};
            prevAprRate[lineid][IntRate]["APR"] = APR;
            return { ...prevAprRate };
          });
          if (isUpdateSelectedRate) {
            setSelectedRate((prevSelectedRate) => {
              return { ...prevSelectedRate, APR };
            });
          }
        }
        return APR;
      });
    } catch (error) {
      console.log("Error in handleGetAPR ==>", error);
    }
  };
  const handleGetCashToClose = async (
    lineId,
    lockPeriodId,
    isUpdateSelectedRate,
    rate
  ) => {
    handleAPI({
      name: "getCashToClose",
      params: { loanId, lineId },
    }).then((response) => {
      const iCashToClose = JSON.parse(response)
        .filter(({ lockperiod }) => lockperiod == lockPeriodId)
        .reduce((acc, { IntRate, cashtoclose }) => {
          acc[IntRate.toFixed(4)] = cashtoclose;
          return acc;
        }, {});
      setCashToCloseDetails((prevCashToCloseDetails) => {
        return { ...prevCashToCloseDetails, [lineId]: iCashToClose };
      });
      if (isUpdateSelectedRate) {
        setSelectedRate((prevSelectedRate) => {
          return {
            ...prevSelectedRate,
            cashToClose: iCashToClose[rate?.toFixed(4)],
          };
        });
      }
    });
  };
  const handleGetARM = async (lineid, IntRate, LockPeriod) => {
    handleAPI({
      name: "GetARMDetails",
      apiName: "RateLockAPI",
      params: { lineid, IntRate, LockPeriodID: LockPeriod },
    }).then(() => {
      setTimeout(() => {
        handleGetAPR(lineid, IntRate, LockPeriod);
      }, 2000);
    });
  };
  const handleUpdatePropertyInfo = (key, value) => {
    setLoanBoardingData((prevLoanBoardingData) => {
      prevLoanBoardingData["DataOut"][3]["PropertyInfo"][0][key] = value;
      return { ...prevLoanBoardingData };
    });
  };
  const handleUpdateBorrower = (index, key, value) => {
    setLoanBoardingData((prevLoanBoardingData) => {
      prevLoanBoardingData["DataOut"][2]["BorrInfo"][index][key] = value;
      return { ...prevLoanBoardingData };
    });
  };

  const AddressInformationBestFit = () => {
    const isButtonDisabled =
      true || !subjectZip || ["rateSelect&BestFit"].includes(processingStatus);

    return (
      <View style={{ width: "100%", paddingBottom: 10 }}>
        <CustomText bold style={styles["rateSummary"]}>
          Missing Information
        </CustomText>
        <CustomText
          style={{
            fontSize: web ? 16 : 14,
            marginBottom: 15,
            paddingHorizontal: 20,
          }}
        >
          Please enter the following information to continue.
        </CustomText>
        <View
          style={{
            width: web ? "100%" : "90%",
            alignSelf: "center",
            marginTop: 15,
            maxHeight: web ? "55vh" : Dimensions.get("window").height - 450,
          }}
        >
          {requiredFieldsObj.length > 0 && (
            <ScrollContainer showScrollBar>
              {requiredFieldsObj.map((item, index) => {
                if (item["field"]) {
                  item["field"].forEach((field) => {
                    field["ColumnValue"] = iLoanData[field["ColumnName"]] || "";
                  });
                } else
                  item["ColumnValue"] = iLoanData[item["ColumnName"]] || "";
                return (
                  <TouchableOpacity
                    activeOpacity={1}
                    key={index}
                    style={{
                      marginHorizontal: web ? 20 : 0,
                    }}
                  >
                    <Title
                      text={item["Title"]}
                      style={{
                        ...styles["rateSummary"],
                        alignSelf: "flex-start",
                        textAlign: "left",
                        fontSize: web ? 20 : 19,
                      }}
                    />
                    {item["type"] === 1 ? (
                      <View style={{ flex: 1 }}>
                        {item["Options"]?.map((item_, index) => (
                          <Option
                            autoFocus={index == 0}
                            key={index}
                            style={{}}
                            text={item_["text"]}
                            value={item_["value"] === item["ColumnValue"]}
                            onPress={() =>
                              handleRequiredFieldData(
                                item["ColumnName"],
                                item_["value"]
                              )
                            }
                          />
                        ))}
                      </View>
                    ) : item["type"] === 3 ? (
                      <>
                        <Dropdown
                          isValid={item["isValid"]}
                          label={item["label"]}
                          options={item["Option"]}
                          value={item["ColumnValue"]}
                          onSelect={(item_) => {
                            handleRequiredFieldData(
                              item["ColumnName"],
                              item_["value"]
                            );
                          }}
                          placeholder={item["placeholder"] || ""}
                          isMap={item["isMap"]}
                        />
                      </>
                    ) : item["label"] !== "Down Payment" ? (
                      <InputBox
                        keyboardType={item["keyboardType"]}
                        maxLength={item["maxLength"]}
                        validate={item["isValid"]}
                        forceValidation={item["forceValidation"]}
                        autoFocus={index == 0}
                        label={item["label"]}
                        isCurrency={item["isCurrency"]}
                        placeholder={item["placeholder"] || item["label"]}
                        onBlur={async () => {
                          if (item["onBlurFunction"]) {
                            if (
                              "handleCalculateDownPaymentPer" ===
                              item["onBlurFunction"]
                            ) {
                              handleCalculateDownPaymentPer();
                            } else if (
                              "DownPmtOnChange" === item["onBlurFunction"]
                            ) {
                              DownPmtOnChange();
                            } else if (
                              "LnAmtExcChange" === item["onBlurFunction"]
                            ) {
                              LnAmtExcChange();
                            } else if (
                              "CalculateDownPayment" === item["onBlurFunction"]
                            ) {
                              CalculateDownPayment();
                            } else if (
                              [
                                "Refi_Estmt_LnAmt",
                                "CashOutAmount",
                                "PaidOff",
                              ].includes(item["onBlurFunction"])
                            ) {
                              CalculateLnAmt(item["onBlurFunction"]);
                            }
                          } else if (item["ColumnName"] === "subjectZip") {
                            let zipCode = iLoanData["subjectZip"];
                            if (zipCode.length === 5) {
                              let { city, state } =
                                await handleGetZipCodeDetails(zipCode);
                              handleRequiredFieldData("subjectCity", city);
                              handleRequiredFieldData("subjectState", state);
                            }
                          }
                        }}
                        onChangeText={(text) => {
                          try {
                            handleRequiredFieldData(item["ColumnName"], text);
                          } catch (e) {}
                        }}
                        value={item["ColumnValue"]?.toString()}
                      />
                    ) : (
                      <>
                        <View style={{ flex: 1, flexDirection: "row" }}>
                          <View
                            style={[
                              styles.inputBoxContainer,
                              {
                                borderColor: "gray",
                                width: "100%",
                              },
                            ]}
                          >
                            <CustomText
                              bold={true}
                              style={styles.inputBoxLabel}
                            >
                              {item["label"] || ""}
                            </CustomText>
                            <CustomTextInput
                              onChangeText={(text) => {
                                handleRequiredFieldData(
                                  item["field"][0]["ColumnName"],
                                  text
                                );
                              }}
                              isCurrency={item["field"][0]["isCurrency"]}
                              keyboardType={item["field"][0]["keyboardType"]}
                              value={
                                item["field"][0]["ColumnValue"]?.toString() ||
                                ""
                              }
                              onBlur={DownPmtOnChange}
                              placeholder={
                                item["field"][0]["placeholder"] ||
                                item["field"][0]["label"]
                              }
                              style={[
                                styles.inputBox,
                                { width: "63%", marginRight: 10 },
                              ]}
                              autoCapitalize={"none"}
                            />
                            <CustomTextInput
                              onChangeText={(text) =>
                                handleRequiredFieldData(
                                  item["field"][1]["ColumnName"],
                                  text
                                )
                              }
                              value={
                                item["field"][1]["ColumnValue"]?.toString() ||
                                ""
                              }
                              keyboardType={item["field"][1]["keyboardType"]}
                              isCurrency={item["field"][1]["isCurrency"]}
                              onBlur={CalculateDownPayment}
                              placeholder={
                                item["field"][1]["placeholder"] ||
                                item["field"][1]["label"]
                              }
                              style={[styles.inputBox, { width: "30%" }]}
                              autoCapitalize={"none"}
                            />
                            <CustomText
                              style={{
                                color: "#999",
                                fontSize: 14,
                                marginTop: 5,
                                marginLeft: 3,
                              }}
                              bold={true}
                            >
                              %
                            </CustomText>
                          </View>
                        </View>
                      </>
                    )}
                  </TouchableOpacity>
                );
              })}
            </ScrollContainer>
          )}
        </View>
        <Button
          // disabled={isButtonDisabled }
          onPress={() => {
            if (!isButtonDisabled || true) {
              setProcessingStatus("rateSelect&BestFit");

              const fieldObj = requiredFieldsObj.flatMap((item) => {
                if (item["field"])
                  return item["field"].map(({ ColumnName }) => ({
                    ColumnName,
                    ColumnValue: iLoanData[ColumnName],
                  }));
                return {
                  ColumnName: item["ColumnName"],
                  ColumnValue: iLoanData[item["ColumnName"]],
                };
              });
              if (
                fieldObj
                  .map(({ ColumnName }) => ColumnName)
                  .includes("subjectZip")
              ) {
                handleSaveSubjectProperty();
                //   () => {
                //   setModalDetails({
                //     visible: false,
                //   });
                //   handleGetLoanBoardingData(0, {
                //     processName: "selectLoanProduct",
                //   });
                // }
              }
              handleSaveRequiredFields(fieldObj, () => {
                handleGetLoanBoardingData(0, {
                  processName: "selectLoanProduct",
                });
              });
              setModalDetails({
                visible: false,
              });
              setProcessingStatus("autoSelectingProduct");
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <View>
                {["rateSelect&BestFit"].includes(processingStatus) && (
                  <View style={{ width: 18, height: 12 }}>
                    <ArrowSpinner color="#fff" isSpinner={true} size={18} />
                  </View>
                )}
              </View>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#fff",
                }}
              >
                {["rateSelect&BestFit"].includes(processingStatus)
                  ? "  Saving..."
                  : "Save"}
              </CustomText>
            </>
          }
        />
        <Button
          disabled={["rateSelect&Lock", "rateSelect"].includes(
            processingStatus
          )}
          buttonType="secondary"
          onPress={() => {
            if (!["rateSelect&BestFit"].includes(processingStatus)) {
              setModalDetails({
                visible: false,
              });
              setProcessingStatus(null);
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#508BC9",
                }}
              >
                Cancel
              </CustomText>
            </>
          }
        />
      </View>
    );
  };
  const AddressInformation = () => {
    const { PropertyInfo } = loanBoardingData["DataOut"][3],
      {
        SubjectAddress = "",
        SubjectZip = "",
        SubjectCity = "",
        SubjectState,
      } = PropertyInfo[0];

    const isButtonDisabled =
      !SubjectAddress ||
      !SubjectZip ||
      !SubjectCity ||
      !SubjectState ||
      ["rateSelect&Lock", "rateSelect"].includes(processingStatus);

    return (
      <View style={{ width: "100%" }}>
        <CustomText bold style={styles["rateSummary"]}>
          Property Address Information
        </CustomText>
        <View style={{ width: "90%", alignSelf: "center", marginTop: 15 }}>
          <InputBox
            label="Property Street Address"
            placeholder="Property Street Address"
            onChangeText={(text) =>
              handleUpdatePropertyInfo("SubjectAddress", text)
            }
            value={SubjectAddress}
          />
          <InputBox
            label="Property Zip Code"
            placeholder="Property Zip Code"
            onChangeText={(text) =>
              handleUpdatePropertyInfo("SubjectZip", text)
            }
            keyboardType="numeric"
            value={SubjectZip}
            onBlur={async () => {
              let zipCode = SubjectZip;
              if (zipCode.length === 5) {
                let { city, state } = await handleGetZipCodeDetails(zipCode);

                handleUpdatePropertyInfo("SubjectCity", city);
                handleUpdatePropertyInfo("SubjectState", state);
              }
            }}
          />
          <InputBox
            label="Property City"
            placeholder="Property City"
            onChangeText={(text) =>
              handleUpdatePropertyInfo("SubjectCity", text)
            }
            value={SubjectCity}
          />
          <Dropdown
            label="Property State"
            options={stateOptions}
            value={
              !true
                ? stateOptions.filter((e) => e["value"] == SubjectState)[0]
                    ?.label
                : SubjectState
            }
            onSelect={({ value }) => {
              handleUpdatePropertyInfo("SubjectState", value);
            }}
            placeholder="State"
            isMap={true}
          />
        </View>
        <Button
          disabled={isButtonDisabled}
          onPress={() => {
            if (!isButtonDisabled) {
              handleLockRate("AddressInfoSection");
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <View>
                {["rateSelect&Lock", "Saving"].includes(processingStatus) && (
                  <View style={{ width: 18, height: 12 }}>
                    <ArrowSpinner color="#fff" isSpinner={true} size={18} />
                  </View>
                )}
              </View>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#fff",
                }}
              >
                {["rateSelect&Lock", "Saving"].includes(processingStatus) ? (
                  <>
                    {processingStatus === "Saving"
                      ? "  Saving..."
                      : "  Locking your rate..."}
                  </>
                ) : (
                  "Save & Lock"
                )}
              </CustomText>
            </>
          }
        />
        <Button
          disabled={["rateSelect&Lock", "rateSelect"].includes(
            processingStatus
          )}
          buttonType="secondary"
          onPress={() => {
            if (!["rateSelect&Lock", "rateSelect"].includes(processingStatus)) {
              setModalDetails({
                visible: false,
              });
              setProcessingStatus(null);
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#508BC9",
                }}
              >
                Cancel
              </CustomText>
            </>
          }
        />
      </View>
    );
  };
  const SSNInformation = () => {
    const { BorrInfo } = loanBoardingData["DataOut"][2],
      isButtonDisabled =
        BorrInfo.filter(({ SSN }) => testSSN(SSN)).length ||
        ["rateSelect&Lock", "rateSelect"].includes(processingStatus);
    return (
      <View>
        <CustomText bold style={styles["rateSummary"]}>
          Please Confirm Borrower Information
        </CustomText>
        <CustomText style={{ fontSize: web ? 15 : 13 }}>
          Great, let's Lock your Rate. Before proceeding, please enter the
          Social Security Number.
        </CustomText>
        <View style={{ width: "90%", alignSelf: "center", marginTop: 15 }}>
          {BorrInfo.map(
            ({ FirstName = "", LastName = "", SSN = "" }, index) => {
              return (
                <View key={index}>
                  <CustomText
                    style={{
                      fontSize: web ? 16 : 14,
                      color: "black",
                      height: 35,
                    }}
                    bold
                  >
                    {FirstName || LastName
                      ? `${FirstName} ${LastName}`
                      : `borrower ${index + 1}`}
                  </CustomText>
                  <InputBox
                    label="Social Security Number"
                    placeholder="SSN"
                    maxLength={9}
                    keyboardType="numeric"
                    forceValidation={testSSN(SSN)}
                    onBlur={() => {
                      handleUpdateBorrower(index, "SSN", formatSSN(SSN));
                    }}
                    onChangeText={(text) => {
                      handleUpdateBorrower(index, "SSN", text);
                    }}
                    value={SSN}
                  />
                </View>
              );
            }
          )}
        </View>
        <Button
          disabled={isButtonDisabled}
          onPress={() => {
            if (!isButtonDisabled) {
              setProcessingStatus("rateSelect&Lock");
              handleLockRate("SSNSection");
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#fff",
                }}
              >
                {["rateSelect&Lock", "Saving"].includes(processingStatus) ? (
                  <>
                    <ArrowSpinner color="#fff" isSpinner={true} size={18} />
                    {processingStatus === "Saving"
                      ? "  Saving..."
                      : "  Locking your rate..."}
                  </>
                ) : (
                  "Save & Lock"
                )}
              </CustomText>
            </>
          }
        />
        <Button
          disabled={["rateSelect&Lock", "rateSelect"].includes(
            processingStatus
          )}
          buttonType="secondary"
          onPress={() => {
            if (!["rateSelect&Lock", "rateSelect"].includes(processingStatus)) {
              setModalDetails({
                visible: false,
              });
              setProcessingStatus(null);
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#508BC9",
                }}
              >
                Cancel
              </CustomText>
            </>
          }
        />
      </View>
    );
  };
  const RateSummary = () => {
    const { Rate, LineId, points, MonthlyPayment, cashToClose } = selectedRate,
      { APR = "Calculating" } = aprRateState?.[LineId]?.[Rate] || {};

    return (
      <View style={{ width: "100%" }}>
        <CustomText bold style={styles["rateSummary"]}>
          Interest Rate Summary
        </CustomText>
        <View
          style={{
            borderBottomColor: "#C6C6C6",
            borderBottomWidth: 2,
            width: "90%",
            flexDirection: "row",
            alignSelf: "center",
          }}
        ></View>
        <View style={[styles["rateSummaryRow"], { justifyContent: "center" }]}>
          <View
            style={[
              {
                width: 140,
                textAlign: "center",
                borderRadius: 10,
              },
              web
                ? { boxShadow: "0px 1px 4px 0px #00000073" }
                : generateBoxShadowStyle(1, 2, "black", 0.2, 3, 8, "black"),
            ]}
          >
            <LinearGradient
              colors={["#C6F561", "#B4F231", "#B4F231"]}
              style={[
                {
                  paddingHorizontal: 0,
                  paddingVertical: web ? 15 : 12,
                  borderRadius: web ? 12 : 8,
                  overflow: "hidden",
                },
              ]}
            >
              <CustomText
                style={[styles["rateValue"], { color: "black" }]}
                bold
              >
                {![
                  "pageLoading",
                  "autoSelectingProduct",
                  "searchingProducts",
                ].includes(processingStatus) ? (
                  formatPercentage(Rate)
                ) : (
                  <ArrowSpinner color="black" isSpinner={true} size={20} />
                )}
              </CustomText>
              <CustomText
                style={[styles["rateValueLabel"], { color: "black" }]}
              >
                Interest Rate
              </CustomText>
            </LinearGradient>
          </View>
        </View>
        <View style={styles["rateSummaryRow"]}>
          <View style={styles["rateValueWrapper"]}>
            <CustomText style={[styles["rateValue"]]} bold>
              {APR === "Calculating" ? (
                <View style={{ width: 20, height: 10 }}>
                  <ArrowSpinner
                    size={web ? 19 : 15}
                    isSpinner={true}
                    color="black"
                  />
                </View>
              ) : (
                APR
              )}
            </CustomText>
            <CustomText style={[styles["rateValueLabel"]]}>APR</CustomText>
          </View>
          <View style={styles["rateValueWrapper"]}>
            <CustomText style={[styles["rateValue"]]} bold>
              {points}
            </CustomText>
            <CustomText style={[styles["rateValueLabel"]]}>Points</CustomText>
          </View>
        </View>
        <View style={styles["rateSummaryRow"]}>
          <View style={styles["rateValueWrapper"]}>
            <CustomText style={[styles["rateValue"]]} bold>
              {![
                "pageLoading",
                "autoSelectingProduct",
                "searchingProducts",
              ].includes(processingStatus) ? (
                formatCurrency(cleanValue(MonthlyPayment), 2)
              ) : (
                <View style={{ width: 20, height: 10 }}>
                  <ArrowSpinner
                    size={web ? 19 : 15}
                    isSpinner={true}
                    color="black"
                  />
                </View>
              )}
            </CustomText>
            <CustomText style={[styles["rateValueLabel"]]}>
              Estimated Payment (P&I)
            </CustomText>
          </View>
          <View style={styles["rateValueWrapper"]}>
            <CustomText style={[styles["rateValue"]]} bold>
              {[
                "pageLoading",
                "autoSelectingProduct",
                "searchingProducts",
              ].includes(processingStatus) ? (
                <View style={{ width: 20, height: 10 }}>
                  <ArrowSpinner
                    size={web ? 19 : 15}
                    isSpinner={true}
                    color="black"
                  />
                </View>
              ) : (
                formatCurrency(cleanValue(cashToClose), 2)
              )}
            </CustomText>
            <CustomText style={[styles["rateValueLabel"]]}>
              Estimated Cash to Close
            </CustomText>
          </View>
        </View>
        {priceAvailability === "ratesExpired" && (
          <CustomText
            style={{
              fontSize: web ? 12 : 10,
              color: "#B73333",
              marginTop: 15,
              textAlign: "center",
            }}
            bold
          >
            Interest Rates are currently unavailable.
          </CustomText>
        )}
        <Button
          disabled={
            ["rateSelect&Lock", "rateSelect"].includes(processingStatus) ||
            priceAvailability === "ratesExpired"
          }
          onPress={() => {
            // setProcessingStatus("SSNDetails");
            handleLockRateProceed();
          }}
          style={{
            width: "91%",
            marginHorizontal: 0,
            marginVertical: 8,
            marginTop: 10,
          }}
          title={
            <>
              <View>
                {["rateSelect&Lock"].includes(processingStatus) && (
                  <View style={{ width: 18, height: 12 }}>
                    <ArrowSpinner color="#fff" isSpinner={true} size={18} />
                  </View>
                )}
              </View>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#fff",
                }}
              >
                {["rateSelect&Lock"].includes(processingStatus)
                  ? "  Locking your rate..."
                  : "Lock This Rate"}
              </CustomText>
            </>
          }
        />
        {!["changeRate", "floatDown"].includes(processName) && ( // && isSmallScreen
          <Button
            disabled={["rateSelect&Lock", "rateSelect"].includes(
              processingStatus
            )}
            buttonType="secondary"
            onPress={() => {
              if (
                !["rateSelect&Lock", "rateSelect"].includes(processingStatus)
              ) {
                setProcessingStatus("rateSelect");
                handleSelectRate();
              }
            }}
            style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
            title={
              <>
                {["rateSelect"].includes(processingStatus) && (
                  <View style={{ width: 18, height: 12 }}>
                    <ArrowSpinner color="#508BC9" isSpinner={true} size={18} />
                  </View>
                )}
                <CustomText
                  bold
                  style={{
                    fontSize: 17,
                    color: "#508BC9",
                  }}
                >
                  {["rateSelect"].includes(processingStatus)
                    ? "  Floating your rate..."
                    : "Float This Rate"}
                </CustomText>
              </>
            }
          />
        )}
        <Button
          disabled={["rateSelect&Lock", "rateSelect"].includes(
            processingStatus
          )}
          buttonType="secondary"
          onPress={() => {
            if (!["rateSelect&Lock", "rateSelect"].includes(processingStatus)) {
              setModalDetails({
                visible: false,
              });
              setProcessingStatus(null);
            }
          }}
          style={{ width: "91%", marginHorizontal: 0, marginVertical: 8 }}
          title={
            <>
              <CustomText
                bold
                style={{
                  fontSize: 17,
                  color: "#508BC9",
                }}
              >
                Cancel
              </CustomText>
            </>
          }
        />
      </View>
    );
  };
  const ViewRateOption = useMemo(() => {
    const {
        showFloatDown = false,
        showChangeRate = false,
        showCancelLock = false,
        showLockExtend = false,
        showLockBtn = false,
      } = lockConfirmationDetails,
      extendLock = showLockExtend || showLockBtn;
    let count = 1;
    if (extendLock) count++;
    if (showChangeRate) count++;
    if (showFloatDown) count++;

    return (
      <View
        style={{
          zIndex: 2,
          alignSelf: "center",
          marginTop: web ? 15 : 10,
          marginBottom: web ? 20 : 10,
          flexDirection: web ? "column" : "column-reverse",
        }}
      >
        <TouchableOpacity
          ref={OptionButton}
          activeOpacity={1}
          onPress={handleOpenOption}
          style={{
            zIndex: 2,
            paddingHorizontal: 30,
            paddingVertical: web ? 10 : 8,
            borderRadius: 0,
            width: web ? 250 : 195,
            backgroundColor: "#508BC9",
            borderWidth: 1,
            borderColor: "#295B9A",
            borderRadius: 5,
          }}
        >
          <CustomText
            style={{
              color: "#fff",
              alignSelf: "center",
              fontSize: web ? 14 : 12,
            }}
            bold
          >
            View Rate Options{"  "}
            <Icon
              size={web ? 17 : 15}
              name={`chevron-${optionDetails["visible"] ? "up" : "down"}`}
            />
          </CustomText>
        </TouchableOpacity>
        {optionDetails["visible"] && (
          <>
            {/* <Modal visible={true} transparent animationType="fade"> */}
            <TouchableOpacity
              activeOpacity={1}
              style={[
                {
                  height: "100%",
                },
                !web && {
                  position: "absolute",
                },
              ]}
              onPress={() =>
                setOptionDetails({ ...optionDetails, visible: false })
              }
            >
              <View
                style={[
                  {
                    backgroundColor: "#fff",
                    position: web ? "absolute" : "relative",
                    zIndex: 3,
                    width: web ? 250 : 190,
                    borderColor: "#d3dadf",
                    borderWidth: 2,
                    boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                  },
                  !web && {
                    bottom: optionDetails["bottom"] + 39.5 * count,
                    // left: optionDetails["left"],
                    opacity: optionDetails["opacity"],
                  },
                ]}
              >
                <>
                  {Boolean(extendLock) && (
                    <RateOption
                      onPress={() => {
                        handleExtendRateLock({});
                      }}
                    >
                      Extend Rate Lock
                    </RateOption>
                  )}

                  {Boolean(showChangeRate) && (
                    <RateOption
                      onPress={async () => {
                        handleChangeRate({});
                      }}
                    >
                      Select a Different Interest Rate
                    </RateOption>
                  )}
                  {Boolean(showFloatDown) && (
                    <RateOption
                      onPress={() => {
                        handleFloatDown();
                      }}
                    >
                      Rate Float Down
                    </RateOption>
                  )}
                  <RateOption
                    disable={!showCancelLock}
                    onPress={() => {
                      setLockConfirmationDetails(
                        (prevLockConfirmationDetails) => ({
                          ...prevLockConfirmationDetails,
                          cancelLockReason: "",
                          isCancelLock: true,
                        })
                      );
                      setOptionDetails({
                        ...optionDetails,
                        visible: false,
                      });
                      // setProcessingStatus("cancelLockSection");
                      handleGetCancelLock();
                    }}
                  >
                    Cancel Rate Lock{"  "}
                  </RateOption>
                </>
              </View>
            </TouchableOpacity>
            {/* </Modal> */}
          </>
        )}
      </View>
    );
  }, [optionDetails, lockConfirmationDetails]);

  const FloatedGrettings = () => {
    let { Rate = "", programName = "" } = selectedRate;
    return (
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          setOptionDetails({ ...optionDetails, visible: false });
        }}
        style={{ backgroundColor: "#fff", flex: 1 }}
      >
        <View style={[styles["titleWrapper"], { marginBottom: web ? 25 : 0 }]}>
          <CustomText
            style={[styles["title"], { marginTop: web ? 10 : 5 }]}
            bold
          >
            Rate Floated
          </CustomText>
        </View>
        <LinearGradient
          colors={["#f6f6f6", "#e8e8e8", "#e8e8e8"]}
          style={[
            {
              alignItems: "center",
              justifyContent: "space-evenly",
              margin: 18,
              padding: 20,
              borderRadius: 12,
              paddingBottom: 0,
            },
            web ? { boxShadow: "0px 4px 16px 0px #00000040" } : {},
          ]}
        >
          <View style={{ width: "100%" }}>
            <LinearGradient
              colors={["#C6F561", "#B4F231", "#B4F231"]}
              style={[
                {
                  paddingHorizontal: 10,
                  paddingVertical: web ? 15 : 12,
                  borderRadius: 12,
                  flexDirection: "row",
                  paddingLeft: 15,
                },
                web
                  ? { boxShadow: "0px 1px 4px 0px #00000073" }
                  : generateBoxShadowStyle(2, 5, "black", 0.2, 3, 8, "black"),
              ]}
            >
              <MaterialIcons name="check-circle" size={20} color="black" />
              <CustomText
                style={{
                  marginLeft: 15,
                }}
              >
                <View>
                  <CustomText
                    style={{
                      fontSize: web ? 16 : 13,
                      color: "#000000",
                      paddingRight: 10,
                    }}
                    bold
                  >
                    Congratulations, {userName}!
                  </CustomText>
                </View>
                <View style={{ marginTop: web ? 5 : 0 }}>
                  <CustomText
                    style={{
                      fontSize: web ? 15 : 12,
                      color: "#000000",
                      textAlign: "center",
                    }}
                  >
                    Your rate has been floated.
                  </CustomText>
                </View>
              </CustomText>
            </LinearGradient>

            <View
              style={{
                marginTop: 15,
                borderBottomColor: "#C6C6C6",
                borderBottomWidth: web ? 2 : 1,
                width: "100%",
                flexDirection: "row",
                alignSelf: "center",
              }}
            ></View>
            <View
              style={[styles["rateSummaryRow"], { justifyContent: "center" }]}
            >
              <View
                style={[
                  {
                    width: 140,
                    textAlign: "center",
                    borderRadius: 10,
                  },
                  web
                    ? { boxShadow: "0px 1px 4px 0px #00000073" }
                    : generateBoxShadowStyle(1, 2, "black", 0.2, 3, 8, "black"),
                ]}
              >
                <LinearGradient
                  colors={["#f8f8f8", "#f8f8f8", "#f8f8f8"]}
                  style={[
                    {
                      paddingHorizontal: 0,
                      paddingVertical: web ? 15 : 12,
                      borderRadius: web ? 12 : 8,
                      overflow: "hidden",
                    },
                  ]}
                >
                  <CustomText
                    style={[styles["rateValue"], { color: "black" }]}
                    bold
                  >
                    {formatPercentage(cleanValue(Rate))}
                  </CustomText>
                  <CustomText
                    style={[styles["rateValueLabel"], { color: "black" }]}
                  >
                    Interest Rate
                  </CustomText>
                </LinearGradient>
              </View>
            </View>
            <CustomText
              style={[
                {
                  color: "#404040",
                  textAlign: "center",
                  fontSize: web ? 12 : 10,
                  marginTop: 10,
                  marginBottom: 5,
                },
                web
                  ? {
                      fontWeight: 400,
                    }
                  : ios
                  ? { alignSelf: "center" }
                  : {},
              ]}
              bold
            >
              Loan Program:{" "}
              {programName ? (
                programName
              ) : (
                <View style={{ width: 12, height: 6 }}>
                  <ArrowSpinner size={12} isSpinner={true} color="black" />
                </View>
              )}
            </CustomText>
          </View>
          <Button
            onPress={handleNextClick}
            style={{
              width: "50%",
              marginHorizontal: 0,
              marginVertical: 20,
            }}
            title={
              <>
                <CustomText
                  bold
                  style={{
                    fontSize: 17,
                    color: "#fff",
                  }}
                >
                  Continue
                </CustomText>
              </>
            }
          />
          <CustomText
            style={{ marginBottom: web ? 20 : 15, fontSize: web ? 11 : 9 }}
          >
            If you have any questions about the below info, please reach out to
            your Loan Officer
          </CustomText>
        </LinearGradient>
      </TouchableOpacity>
    );
  };
  const LockConfirmation = () => {
    let {
        comprateadj: Rate = "-",
        ratepattern: loanProgramName,
        compperiodreq: lockPeriodDaysCount,
        complockexpire: lockPeriodDate,
        comppointsadj: iPoints = "-",
        MonthlyPayment = "-",
        compexpiredate: cashToClose = "-",
        ProcessLineId,
        lockExpDate = null,
        APR = "Calculating",
      } = lockConfirmationDetails,
      // { APR = "Calculating" } =
      //   aprRateState?.[ProcessLineId]?.[cleanValue(Rate)] || {},
      points = getPoints(iPoints) || "";

    if (cashToClose === "-" && selectedRate["cashToClose"]) {
      cashToClose = selectedRate["cashToClose"];
    }

    lockExpDate =
      lockExpDate ||
      (lockPeriodDate && lockPeriodDaysCount
        ? `${formatDate(lockPeriodDate)}`
        : null);

    return (
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          setOptionDetails({ ...optionDetails, visible: false });
        }}
        style={{ backgroundColor: "#fff", flex: 1 }}
      >
        <View style={[styles["titleWrapper"], { marginBottom: web ? 25 : 0 }]}>
          <CustomText
            style={[styles["title"], { marginTop: web ? 10 : 5 }]}
            bold
          >
            Rate Lock Details
          </CustomText>
        </View>
        <LinearGradient
          colors={["#f6f6f6", "#e8e8e8", "#e8e8e8"]}
          style={[
            {
              alignItems: "center",
              justifyContent: "space-evenly",
              margin: 18,
              padding: 20,
              borderRadius: 12,
              paddingBottom: 0,
            },
            web ? { boxShadow: "0px 4px 16px 0px #00000040" } : {},
          ]}
        >
          <View style={{ width: "100%" }}>
            <LinearGradient
              colors={["#C6F561", "#B4F231", "#B4F231"]}
              style={[
                {
                  paddingHorizontal: 10,
                  paddingVertical: web ? 15 : 12,
                  borderRadius: 12,
                  flexDirection: "row",
                  paddingLeft: 15,
                },
                web
                  ? { boxShadow: "0px 1px 4px 0px #00000073" }
                  : generateBoxShadowStyle(2, 5, "black", 0.2, 3, 8, "black"),
              ]}
            >
              <MaterialIcons name="lock" size={20} color="black" />
              <CustomText
                style={{
                  marginLeft: 15,
                }}
              >
                <View>
                  <CustomText
                    style={{
                      fontSize: web ? 16 : 13,
                      color: "#000000",
                      paddingRight: 10,
                    }}
                    bold
                  >
                    Congratulations, {userName}!
                  </CustomText>
                </View>
                <View style={{ marginTop: web ? 5 : 0 }}>
                  <CustomText
                    style={{
                      fontSize: web ? 15 : 12,
                      color: "#000000",
                      textAlign: "center",
                    }}
                  >
                    Your interest rate is Locked.
                  </CustomText>
                </View>
              </CustomText>
            </LinearGradient>

            <View
              style={{
                marginTop: 15,
                borderBottomColor: "#C6C6C6",
                borderBottomWidth: web ? 2 : 1,
                width: "100%",
                flexDirection: "row",
                alignSelf: "center",
              }}
            ></View>

            <CustomText
              style={[
                {
                  color: "#404040",
                  textAlign: "center",
                  fontSize: web ? 14 : 12,
                  marginTop: 10,
                  marginBottom: 5,
                },
                web
                  ? {
                      fontWeight: 400,
                    }
                  : ios
                  ? { alignSelf: "center" }
                  : {},
              ]}
              bold
            >
              Loan Program:{" "}
              {loanProgramName ? (
                loanProgramName
              ) : (
                <View style={{ width: 12, height: 6 }}>
                  <ArrowSpinner size={12} isSpinner={true} color="black" />
                </View>
              )}
            </CustomText>
            <View
              style={{
                flexDirection: "row",
                alignSelf: "center",
                marginBottom: web ? 0 : 5,
              }}
            >
              <CustomText
                style={{
                  fontSize: web ? 11 : 9,
                  color: "#666666",
                }}
              >
                Lock Expires On{" "}
                {lockExpDate &&
                !["refreshingLockExpiryDate", "savingRateExtendLock"].includes(
                  processingStatus
                ) ? (
                  <>{lockExpDate}</>
                ) : (
                  <View style={{ width: 12, height: 6 }}>
                    <ArrowSpinner size={12} isSpinner={true} color="black" />
                  </View>
                )}
              </CustomText>
            </View>

            <View
              style={[styles["rateSummaryRow"], { justifyContent: "center" }]}
            >
              <View
                style={[
                  {
                    width: 140,
                    textAlign: "center",
                    borderRadius: 10,
                  },
                  web
                    ? { boxShadow: "0px 1px 4px 0px #00000073" }
                    : generateBoxShadowStyle(1, 2, "black", 0.2, 3, 8, "black"),
                ]}
              >
                <LinearGradient
                  colors={["#f8f8f8", "#f8f8f8", "#f8f8f8"]}
                  style={[
                    {
                      paddingHorizontal: 0,
                      paddingVertical: web ? 15 : 12,
                      borderRadius: web ? 12 : 8,
                      overflow: "hidden",
                    },
                  ]}
                >
                  <CustomText
                    style={[styles["rateValue"], { color: "black" }]}
                    bold
                  >
                    {Rate == "-" ||
                    [
                      "pageLoading",
                      "autoSelectingProduct",
                      "searchingProducts",
                    ].includes(processingStatus) ? (
                      <View style={{ width: 20, height: 10 }}>
                        <ArrowSpinner
                          size={web ? 19 : 15}
                          isSpinner={true}
                          color="black"
                        />
                      </View>
                    ) : (
                      formatPercentage(cleanValue(Rate))
                    )}
                  </CustomText>
                  <CustomText
                    style={[styles["rateValueLabel"], { color: "black" }]}
                  >
                    Interest Rate
                  </CustomText>
                </LinearGradient>
              </View>
            </View>
            <View style={styles["rateSummaryRow"]}>
              <View style={styles["rateValueWrapper"]}>
                <CustomText style={[styles["rateValue"]]} bold>
                  {APR === "Calculating" ? (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  ) : (
                    formatPercentage((APR * 100).toFixed(3))
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>APR</CustomText>
              </View>
              <View style={styles["rateValueWrapper"]}>
                <CustomText
                  style={[
                    styles["rateValue"],
                    {
                      color: points.includes("(") ? "#88AB35" : "#c14242",
                    },
                  ]}
                  bold
                >
                  {points ? (
                    points
                  ) : (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>
                  Points
                </CustomText>
              </View>
            </View>
            <View style={styles["rateSummaryRow"]}>
              <View style={styles["rateValueWrapper"]}>
                <CustomText style={[styles["rateValue"]]} bold>
                  {MonthlyPayment !== "-" &&
                  ![
                    "pageLoading",
                    "autoSelectingProduct",
                    "searchingProducts",
                  ].includes(processingStatus) ? (
                    formatCurrency(cleanValue(MonthlyPayment), 2)
                  ) : (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>
                  Estimated Payment (P&I)
                </CustomText>
              </View>
              <View style={styles["rateValueWrapper"]}>
                <CustomText style={[styles["rateValue"]]} bold>
                  {[
                    "pageLoading",
                    "autoSelectingProduct",
                    "searchingProducts",
                  ].includes(processingStatus) || cashToClose === "-" ? (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  ) : (
                    formatCurrency(cleanValue(cashToClose), 2)
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>
                  Estimated Cash to Close
                </CustomText>
              </View>
            </View>
          </View>

          {ViewRateOption}
          <CustomText
            style={{ marginBottom: web ? 20 : 15, fontSize: web ? 11 : 9 }}
          >
            If you have any questions about the below info, please reach out to
            your Loan Officer
          </CustomText>
        </LinearGradient>
      </TouchableOpacity>
    );
  };
  const FloatConfirmation = () => {
    let {
        Rate = "",
        LineId = "",
        points = "",
        MonthlyPayment = "",
        cashToClose = "Calculating",
        programName = "",
      } = selectedRate,
      { APR = "Calculating" } = aprRateState?.[LineId]?.[Rate] || {};

    if (APR == "Calculating") {
      APR = selectedRate["APR"] || "Calculating";
    }

    return (
      <View style={{ backgroundColor: "#fff", flex: 1 }}>
        <View style={[styles["titleWrapper"], { marginBottom: web ? 25 : 0 }]}>
          <CustomText style={[styles["title"], { marginTop: 10 }]} bold>
            Review Your Interest Rate
          </CustomText>
        </View>
        <LinearGradient
          colors={["#f6f6f6", "#e8e8e8", "#e8e8e8"]}
          style={[
            {
              alignItems: "center",
              justifyContent: "space-evenly",
              margin: 18,
              padding: 20,
              borderRadius: 12,
            },
            web ? { boxShadow: "0px 4px 16px 0px #00000040" } : {},
          ]}
        >
          <View style={{ width: "100%" }}>
            <CustomText
              style={{
                marginBottom: 10,
                textAlign: "center",
                fontSize: web ? 13 : 11,
              }}
              bold
            >
              You are currently floating your interest rate. You can lock in
              your rate using the button below.
            </CustomText>
            <View
              style={{
                borderTopColor: "#C6C6C6",
                borderTopWidth: web ? 2 : 1,
                width: "100%",
                flexDirection: "row",
                alignSelf: "center",
              }}
            ></View>

            <CustomText
              style={[
                {
                  color: "#404040",
                  marginTop: 10,
                  textAlign: "center",
                  fontSize: web ? 11 : 9,
                  marginBottom: 5,
                },
                web
                  ? {
                      fontWeight: 400,
                    }
                  : ios
                  ? { alignSelf: "center" }
                  : {},
              ]}
              bold
            >
              Loan Program:{" "}
              {programName ? (
                programName
              ) : (
                <View style={{ width: 12, height: 6 }}>
                  <ArrowSpinner size={12} isSpinner={true} color="black" />
                </View>
              )}
            </CustomText>

            <View
              style={[styles["rateSummaryRow"], { justifyContent: "center" }]}
            >
              <View
                style={[
                  { width: 140, textAlign: "center", borderRadius: 10 },
                  web
                    ? { boxShadow: "0px 1px 4px 0px #00000073" }
                    : generateBoxShadowStyle(1, 2, "black", 0.2, 1, 8, "black"),
                ]}
              >
                <LinearGradient
                  colors={["#C6F561", "#B4F231", "#B4F231"]}
                  style={[
                    {
                      paddingHorizontal: 0,
                      paddingVertical: web ? 15 : 12,
                      borderRadius: web ? 12 : 8,
                      overflow: "hidden",
                    },
                  ]}
                >
                  <CustomText
                    style={[styles["rateValue"], { color: "black" }]}
                    bold
                  >
                    {Rate == "-" ||
                    [
                      "pageLoading",
                      "autoSelectingProduct",
                      "searchingProducts",
                    ].includes(processingStatus) ? (
                      <View style={{ width: 20, height: 10 }}>
                        <ArrowSpinner
                          size={web ? 19 : 15}
                          isSpinner={true}
                          color="black"
                        />
                      </View>
                    ) : (
                      formatPercentage(cleanValue(Rate))
                    )}
                  </CustomText>
                  <CustomText
                    style={[styles["rateValueLabel"], { color: "black" }]}
                  >
                    Interest Rate
                  </CustomText>
                </LinearGradient>
              </View>
            </View>
            <View style={styles["rateSummaryRow"]}>
              <View style={styles["rateValueWrapper"]}>
                <CustomText style={[styles["rateValue"]]} bold>
                  {APR === "Calculating" ||
                  [
                    "pageLoading",
                    "autoSelectingProduct",
                    "searchingProducts",
                  ].includes(processingStatus) ? (
                    <View style={{ width: 20, height: 20 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  ) : (
                    APR
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>APR</CustomText>
              </View>
              <View style={styles["rateValueWrapper"]}>
                <CustomText
                  style={[
                    styles["rateValue"],
                    {
                      color: points.includes("(") ? "#88AB35" : "#c14242",
                    },
                  ]}
                  bold
                >
                  {points ? (
                    points
                  ) : (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>
                  Points
                </CustomText>
              </View>
            </View>
            <View style={styles["rateSummaryRow"]}>
              <View style={styles["rateValueWrapper"]}>
                <CustomText style={[styles["rateValue"]]} bold>
                  {MonthlyPayment !== "-" &&
                  ![
                    "pageLoading",
                    "autoSelectingProduct",
                    "searchingProducts",
                  ].includes(processingStatus) ? (
                    formatCurrency(cleanValue(MonthlyPayment), 2)
                  ) : (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>
                  Estimated Payment (P&I)
                </CustomText>
              </View>
              <View style={styles["rateValueWrapper"]}>
                <CustomText style={[styles["rateValue"]]} bold>
                  {[
                    "pageLoading",
                    "autoSelectingProduct",
                    "searchingProducts",
                  ].includes(processingStatus) ||
                  cashToClose === "Calculating" ? (
                    <View style={{ width: 20, height: 10 }}>
                      <ArrowSpinner
                        size={web ? 19 : 15}
                        isSpinner={true}
                        color="black"
                      />
                    </View>
                  ) : (
                    formatCurrency(cleanValue(cashToClose), 2)
                  )}
                </CustomText>
                <CustomText style={[styles["rateValueLabel"]]}>
                  Estimated Cash to Close
                </CustomText>
              </View>
            </View>
          </View>
          {priceAvailability === "ratesExpired" && (
            <CustomText
              style={{
                fontSize: web ? 12 : 10,
                color: "#B73333",
                marginTop: 15,
                textAlign: "center",
              }}
              bold
            >
              Interest Rates are currently unavailable.
            </CustomText>
          )}
          <Button
            disabled={
              priceAvailability === "ratesExpired" ||
              [
                "rateSelect&Lock",
                "rateSelect",
                "pageLoading",
                "autoSelectingProduct",
                "searchingProducts",
              ].includes(processingStatus)
            }
            onPress={() => {
              handleLockRateProceed();
            }}
            style={{
              width: "91%",
              marginHorizontal: 0,
              marginVertical: 8,
              marginTop: 10,
            }}
            title={
              <>
                {["rateSelect&Lock"].includes(processingStatus) && (
                  <View style={{ width: 18, height: 12 }}>
                    <ArrowSpinner color="#fff" isSpinner={true} size={18} />
                  </View>
                )}
                <CustomText
                  bold
                  style={{
                    fontSize: 17,
                    color: "#fff",
                  }}
                >
                  {["rateSelect&Lock"].includes(processingStatus)
                    ? "  Locking your rate..."
                    : "Lock This Rate"}
                </CustomText>
              </>
            }
          />
          <Button
            disabled={["rateSelect&Lock", "rateSelect"].includes(
              processingStatus
            )}
            buttonType="secondary"
            onPress={() => {
              setLockConfirmationDetails((prevLockConfirmationDetails) => {
                prevLockConfirmationDetails["isFloated"] = false;
                return { ...prevLockConfirmationDetails };
              });
            }}
            style={{
              width: "91%",
              marginHorizontal: 0,
              marginVertical: 8,
              marginTop: 10,
            }}
            title={
              <>
                <CustomText
                  bold
                  style={{
                    fontSize: 17,
                    color: "#508BC9",
                  }}
                >
                  Change Interest Rate
                </CustomText>
              </>
            }
          />

          <CustomText style={{ marginBottom: 20, fontSize: web ? 11 : 9 }}>
            If you have any questions about the below info, please reach out to
            your Loan Officer
          </CustomText>
        </LinearGradient>
      </View>
    );
  };
  const ModalComponent = useMemo(() => {
    const { width } = Dimensions.get("window"),
      modalStyle = [
        web
          ? {
              width: 422,
              bottom: 0,
              position: "absolute",
              height: "calc(100% - 86px)",
              height: "91%",
              backgroundColor: "#00000082",
              justifyContent: "center",
            }
          : {
              position: "absolute",
              height: "100%",
              backgroundColor: "#00000082",
              justifyContent: "center",
              width: "100%",
            },
        !isSmallScreen &&
          web && {
            left: 377,
          },
      ];
    return (
      <Modal
        visible={modalDetails["visible"]}
        testID={
          !isSmallScreen ? "InterestRateModal" : "InterestRateModalMobile"
        }
        transparent
        animationType="fade"
        deviceWidth={web ? 422 : width}
        style={modalStyle}
      >
        <TouchableOpacity
          activeOpacity={1}
          style={modalStyle}
          onPress={() => {}}
        >
          <LinearGradient
            colors={
              [
                "SSNDetails",
                "addressInfoSection",
                "addressInfoSection-BestFit",
                "rateSelect&BestFit",
              ].includes(processingStatus)
                ? ["#fff", "#fff", "#fff"]
                : ["#f6f6f6", "#e8e8e8", "#e8e8e8"]
            }
            style={[
              {
                alignItems: "center",
                justifyContent: "space-evenly",
                margin: 18,
                paddingHorizontal: [
                  "rateSelect&BestFit",
                  "addressInfoSection-BestFit",
                ].includes(processingStatus)
                  ? 10
                  : 20,
                paddingVertical: 20,
                borderRadius: 12,
              },
              web ? { boxShadow: "0px 4px 16px 0px #00000040" } : {},
            ]}
          >
            {processingStatus === "SSNDetails" ? (
              <>{SSNInformation()}</>
            ) : processingStatus === "addressInfoSection" ? (
              <>{AddressInformation()}</>
            ) : ["rateSelect&BestFit", "addressInfoSection-BestFit"].includes(
                processingStatus
              ) ? (
              <>{AddressInformationBestFit()}</>
            ) : (
              <RateSummary />
            )}
          </LinearGradient>
        </TouchableOpacity>
      </Modal>
    );
  }, [
    modalDetails,
    processingStatus,
    aprRateState,
    loanBoardingData,
    lockConfirmationDetails,
    iLoanData,
    propertyTypeOption,
    requiredFieldsObj,
  ]);

  const AlertComponent = useMemo(() => {
    const {
        visible,
        head = "Error",
        body,
        needCancel,
        needSuccessButton,
        successButtonText,
        successButtonOnPress,
        cancelButtonOnPress = null,
        disableSuccessButton = false,
        preventSuccessPress = false,
      } = alertDetails,
      { width } = Dimensions.get("window"),
      modalStyle = [
        web
          ? {
              width: 422,
              bottom: 0,
              position: "absolute",
              height: "calc(100% - 86px)",
              height: "91%",
              backgroundColor: "#00000082",
              justifyContent: "center",
            }
          : {
              position: "absolute",
              height: "100%",
              backgroundColor: "#00000082",
              justifyContent: "center",
              width: "100%",
            },
        !isSmallScreen &&
          web && {
            left: 377,
          },
      ];

    return (
      <Modal
        testID={
          !isSmallScreen ? "InterestRateModal" : "InterestRateModalMobile"
        }
        visible={visible}
        transparent
        animationType="fade"
        deviceWidth={web ? 422 : width}
        style={modalStyle}
      >
        <TouchableOpacity
          activeOpacity={1}
          style={modalStyle}
          onPress={() => {
            // setModalDetails({
            //   ...modalDetails,
            //   visible: false,
            // })
            //setProcessingStatus(null);
          }}
        >
          <View
            style={[
              {
                backgroundColor: "#fff",
                margin: 25,
                padding: 20,
                borderRadius: 12,
              },
              web ? { boxShadow: "0px 4px 16px 0px #00000040" } : {},
            ]}
          >
            {head && (
              <View
                style={{
                  paddingBottom: 8,
                  borderBottomWidth: 1,
                  borderBottomColor: "#cccccc",
                  marginBottom: web ? 20 : 10,
                }}
              >
                <CustomText
                  style={{
                    fontSize: web ? 20 : 16,
                  }}
                  bold
                >
                  {head}
                </CustomText>
              </View>
            )}
            {body === "cancelLockReason" ? (
              <InputBox
                label="Reason"
                autoFocus={true}
                textAlignVertical="top"
                multiline={true}
                onChangeText={(text) => {
                  setLockConfirmationDetails((prevLockConfirmationDetails) => {
                    return {
                      ...prevLockConfirmationDetails,
                      cancelLockReason: text,
                    };
                  });
                }}
                value={lockConfirmationDetails["cancelLockReason"]?.toString()}
              />
            ) : (
              <CustomText style={{ fontSize: web ? 16 : 14 }}>
                {body}
              </CustomText>
            )}
            <View
              style={{
                flexDirection: "row",
                display: "flex",
                paddingTop: 10,
                marginTop: 15,
                justifyContent: "flex-end",
                borderTopWidth: 1,
                borderTopColor: "#cccccc",
              }}
            >
              {needCancel && (
                <ModalButton
                  buttonType="secondary"
                  style={{
                    backgroundColor: "rgb(108, 117, 125)",
                  }}
                  textStyle={{ color: "#fff" }}
                  onPress={() => {
                    if (cancelButtonOnPress) {
                      cancelButtonOnPress();
                    } else {
                      setModalDetails({
                        visible: false,
                      });
                      setAlertDetails({
                        visible: false,
                      });
                      setProcessingStatus(null);
                    }
                  }}
                  title="Cancel"
                />
              )}
              {needSuccessButton && (
                <ModalButton
                  disableBackgroundColor={
                    lockConfirmationDetails["isCancelLock"] && "#508BC9"
                  }
                  style={{ backgroundColor: "#508BC9" }}
                  disabled={disableSuccessButton}
                  onPress={() => {
                    if (preventSuccessPress) {
                      successButtonOnPress();
                    } else {
                      successButtonOnPress();
                      setModalDetails({
                        visible: false,
                      });
                      setAlertDetails({
                        visible: false,
                      });
                      setProcessingStatus(null);
                      setRateData([]);
                      handleUpdateSearchInfo("isEditMode", true, false);
                    }
                  }}
                  title={successButtonText}
                />
              )}
            </View>
          </View>
        </TouchableOpacity>
      </Modal>
    );
  }, [alertDetails]);

  return (
    <>
      <View
        style={[
          {
            marginVertical: 20,
            marginHorizontal: web ? 20 : 10,
            marginBottom: 50,
            flex: 1,
          },
        ]}
      >
        {processingStatus === "selectingInProgress" && (
          <>
            <View style={styles["titleWrapper"]}>
              <CustomText style={styles["title"]} bold>
                Select Your Interest Rate
              </CustomText>
              <CustomText style={styles["titleDescription"]} bold>
                Click on any rate below to see your estimated Payment and Cash
                to Close.
              </CustomText>
            </View>
            <CustomText
              style={{
                fontSize: web ? 15 : 13,
                color: "#646464",
                marginTop: 15,
                textAlign: "center",
              }}
              bold
            >
              <ArrowSpinner color="black" isSpinner={true} size={15} /> Just one
              moment while we Find the Best Loan Product for you!
            </CustomText>
          </>
        )}
        {lockConfirmationDetails["isLocked"] == true ? (
          <>
            <LockConfirmation />
            {web && (
              <View
                style={{
                  height: optionDetails["visible"] ? 150 : 0,
                  zIndex: -1,
                }}
              ></View>
            )}
          </>
        ) : lockConfirmationDetails["isFloated"] ? (
          <>
            {lockConfirmationDetails["isFloatedGrettings"] ? (
              <FloatedGrettings />
            ) : (
              <FloatConfirmation />
            )}
          </>
        ) : lockConfirmationDetails["isLocked"] == false ? (
          <>
            <ScrollContainer showScrollBar>
              <View style={styles["titleWrapper"]}>
                <CustomText style={styles["title"]} bold>
                  Select Your Interest Rate
                </CustomText>
                <CustomText style={styles["titleDescription"]} bold>
                  Click on any rate below to see your estimated Payment and Cash
                  to Close.
                </CustomText>
              </View>
              {["changeRate", "floatDown"].includes(processName) ? (
                <>
                  {/* <Button
                    buttonType="secondary"
                    disabled={false}
                    style={{
                      marginTop: 10,
                      width: "35%",
                      marginLeft: 0,
                      alignSelf: "flex-start",
                    }}
                    onPress={() => {
                      setProcessingStatus(null);
                      setLockConfirmationDetails(
                        (prevLockConfirmationDetails) => {
                          delete prevLockConfirmationDetails["processName"];
                          return {
                            ...prevLockConfirmationDetails,
                            isLocked: true,
                          };
                        }
                      );
                    }}
                    title={
                      <>
                        <CustomText
                          bold
                          style={{
                            fontSize: 14,
                            color: "#508BC9",
                          }}
                        >
                          Cancel
                        </CustomText>
                      </>
                    }
                  /> */}
                </>
              ) : (
                <View style={[styles["filterWrapper"]]}>
                  {["autoSelectingProduct", "pageLoading"].includes(
                    processingStatus
                  ) && (
                    <View
                      style={[
                        {
                          justifyContent: "center",
                          alignItems: "center",
                          position: "absolute",
                          top: "45%",
                          width: "100%",
                        },
                      ]}
                    >
                      <ArrowSpinner
                        color="#508BC9"
                        isSpinner={true}
                        size={30}
                      />
                    </View>
                  )}
                  <View
                    pointerEvents={
                      (priceAvailability &&
                        priceAvailability !== "ratesExpired") ||
                      ["autoSelectingProduct", "pageLoading"].includes(
                        processingStatus
                      )
                        ? "none"
                        : "auto"
                    }
                    style={
                      (["changeRate", "floatDown"].includes(processName) ||
                        ["autoSelectingProduct", "pageLoading"].includes(
                          processingStatus
                        )) && { opacity: 0.5 }
                    }
                  >
                    <TouchableOpacity
                      activeOpacity={0.8}
                      style={[
                        styles["filetHeader"],
                        !searchInfo["isEditMode"] && { paddingTop: 10 },
                      ]}
                      onPress={() => {
                        handleUpdateSearchInfo("isEditMode", true, false);
                      }}
                    >
                      <CustomText bold style={{ color: "#4D4D4D" }}>
                        Loan Program Filters
                      </CustomText>
                      {!searchInfo["isEditMode"] && (
                        <CustomText
                          style={{
                            color: "#2672CB",
                            alignSelf: "center",
                            fontSize: 12,
                            marginLeft: 15,
                          }}
                          bold
                        >
                          Edit
                        </CustomText>
                      )}
                    </TouchableOpacity>
                    {searchInfo["isEditMode"] && (
                      <>
                        <View style={styles["filterContainerWrapper"]}>
                          <View style={styles["filterContainer"]}>
                            <CustomText bold style={styles["filterHead"]}>
                              Loan Program Type
                            </CustomText>
                            <CustomCheckBoxSelection
                              isMultiple={true}
                              options={loanProgramTypeOptions}
                              color="#508BC9"
                              value={searchInfo["loanType"] || 0}
                              onChange={(value) =>
                                handleUpdateSearchInfo("loanType", value)
                              }
                              size={15}
                            />
                          </View>
                          <View style={styles["filterContainer"]}>
                            <CustomText bold style={styles["filterHead"]}>
                              Loan Term
                            </CustomText>
                            <View>
                              <CustomCheckBoxSelection
                                isMultiple={true}
                                options={loanTermOptions.slice(
                                  0,
                                  loanTermDetails[
                                    loanTermDetails["isExpand"]
                                      ? "totalCount"
                                      : "viewCount"
                                  ]
                                )}
                                color="#508BC9"
                                value={searchInfo["term"] || 0}
                                onChange={(value) =>
                                  handleUpdateSearchInfo("term", value)
                                }
                                size={15}
                              />
                              <TouchableOpacity
                                activeOpacity={1}
                                onPress={() => {
                                  setLoanTermDetails((prevLoanTermDetails) => {
                                    prevLoanTermDetails["isExpand"] =
                                      !prevLoanTermDetails["isExpand"];
                                    return { ...prevLoanTermDetails };
                                  });
                                }}
                                style={[
                                  {
                                    display: "flex",
                                    alignSelf: "center",
                                    flexDirection: "row",
                                  },
                                  web && { cursor: "pointer" },
                                ]}
                              >
                                <CustomText
                                  style={{ fontSize: 13, color: "#508BC9" }}
                                  bold
                                >
                                  {loanTermDetails["isExpand"] ? "-" : "+"}
                                </CustomText>
                                <CustomText
                                  style={{
                                    fontSize: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    height: 17,
                                    marginLeft: 3,
                                  }}
                                >
                                  {loanTermDetails["isExpand"]
                                    ? "Less"
                                    : "More"}
                                </CustomText>
                              </TouchableOpacity>
                            </View>
                          </View>
                          <View style={styles["filterContainer"]}>
                            <CustomText bold style={styles["filterHead"]}>
                              Amortization Type
                            </CustomText>
                            <CustomCheckBoxSelection
                              isMultiple={true}
                              options={amortTypeOptions}
                              color="#508BC9"
                              value={searchInfo["amortType"] || 0}
                              onChange={(value) =>
                                handleUpdateSearchInfo("amortType", value)
                              }
                              size={15}
                            />
                          </View>
                          <View style={styles["filterContainer"]}>
                            <CustomText bold style={styles["filterHead"]}>
                              Lien Position
                            </CustomText>
                            <CustomCheckBoxSelection
                              isMultiple={false}
                              options={lienPositionOptions}
                              color="#508BC9"
                              value={searchInfo["lienPosition"] || 0}
                              onChange={(value) =>
                                handleUpdateSearchInfo("lienPosition", value)
                              }
                              size={15}
                            />
                          </View>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              marginTop: 15,
                            }}
                          >
                            <CustomText
                              bold
                              style={[
                                styles["filterHead"],
                                { paddingBottom: 0 },
                              ]}
                            >
                              Locked Days {"  "}
                            </CustomText>
                            <DropDownButton
                              width={60}
                              options={lockPeriodOptions}
                              value={searchInfo["lockPeriod"] || 0}
                              onSelect={({ value }) =>
                                handleUpdateSearchInfo("lockPeriod", value)
                              }
                            />
                          </View>
                          <ModalButton
                            disabled={
                              // priceAvailability ||
                              handleFilterValidation() ||
                              [
                                "searchingProducts",
                                "savingProducts",
                                "searchFinished",
                                "pageLoading",
                                "autoSelectingProduct",
                              ].includes(processingStatus)
                            }
                            onPress={() => {
                              if (handleGetRequiredFields()) {
                                setProcessingStatus(
                                  "addressInfoSection-BestFit"
                                );
                                setModalDetails({
                                  visible: true,
                                });
                              } else {
                                setRateData(null);
                                handleUpdateSearchInfo(
                                  "isEditMode",
                                  true,
                                  false
                                );
                                setProcessingStatus("savingProducts");
                                handleSearchLoanProducts();
                              }
                            }}
                            style={{
                              alignSelf: "flex-end",
                              paddingVertical: 5,
                              paddingHorizontal: 10,
                              height: 28,
                              width: 200,
                              display: "flex",
                              backgroundColor: "#508BC9",
                              alignItems: "center",
                              marginTop: 10,
                            }}
                            // textStyle={{ marginTop: web ? "-3px" : 0 }}
                            title={
                              <View
                                style={{
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  height: web ? 18 : 28,
                                }}
                              >
                                {[
                                  "searchingProducts",
                                  "savingProducts",
                                ].includes(processingStatus) && (
                                  <View
                                    style={{ width: 18, height: web ? 17 : 28 }}
                                  >
                                    <ArrowSpinner
                                      color="#fff"
                                      isSpinner={true}
                                      size={web ? 18 : 14}
                                    />
                                  </View>
                                )}
                                <CustomText
                                  bold
                                  style={{
                                    fontSize: 11,
                                    color: "#fff",
                                    paddingTop: web ? 0 : 3,
                                  }}
                                >
                                  {[
                                    "searchingProducts",
                                    "savingProducts",
                                  ].includes(processingStatus)
                                    ? "  Searching..."
                                    : "Save & Refresh Loan Products"}
                                </CustomText>
                              </View>
                            }
                          />
                        </View>
                      </>
                    )}
                  </View>
                </View>
              )}
              {
                // priceAvailability === "ratesExpired" ? (
                //   <CustomText
                //     style={{
                //       fontSize: web ? 15 : 13,
                //       color: "#B73333",
                //       marginTop: 15,
                //     }}
                //     bold
                //   >
                //     Interest Rates are currently unavailable.
                //   </CustomText>
                // ) :
                priceAvailability === "priceChanged" ? (
                  <CustomText
                    style={{
                      fontSize: web ? 15 : 13,
                      color: "#646464",
                      marginTop: 15,
                      textAlign: "center",
                    }}
                    bold
                  >
                    <ArrowSpinner color="black" isSpinner={true} size={15} />{" "}
                    Please wait a moment while we refresh this list and obtain
                    the current interest rate pricing...
                  </CustomText>
                ) : (
                  <></>
                )
              }
              {rateData && rateData.length === 0 && (
                <View
                  style={[
                    styles["rateContainerWrapper"],
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row",
                    },
                  ]}
                >
                  <CustomText style={{ fontSize: 14 }} bold>
                    No Loan Products Found
                  </CustomText>
                </View>
              )}
              {rateData ? (
                <>
                  {rateData?.map((itemArray, index) => {
                    const { RateData: rowData = [] } =
                        Object.values(itemArray)[0][5],
                      { LockPeriod = [] } = Object.values(itemArray)[0][4],
                      { Addons = [] } = Object.values(itemArray)[0][6],
                      { LoanProgramDetails = [] } =
                        Object.values(itemArray)[0][1],
                      { LoanData = [] } = Object.values(itemArray)[0][2],
                      { LenderCompAmt = 0, LoanAmt = 0 } = LoanData[0],
                      { RateSheetId } = LoanProgramDetails[0];

                    let LenderCompPoints =
                      (parseFloat(LenderCompAmt) /
                        parseFloat(cleanValue(LoanAmt))) *
                      100;

                    const totalAddons = Addons.reduce((acc, { Disc }) => {
                      return acc + parseFloat(Disc);
                    }, 0);
                    let {
                        Name: programName,
                        LineId,
                        LnProgActiveId,
                        LockDays,
                      } = Object.values(itemArray)[0][1][
                        "LoanProgramDetails"
                      ][0],
                      LockPeriodArray =
                        LockPeriod["length"] > 1
                          ? LockPeriod.filter(
                              ({ LockExpDate }) => LockExpDate == LockDays
                            )
                          : LockPeriod[0];

                    if (LockPeriodArray.length == 0) {
                      LockPeriodArray = LockPeriod.filter(
                        ({ LockPeriodID }) => LockPeriodID == 4
                      );
                    }

                    const { COlID, LockPeriods } = LockPeriodArray[0] || {},
                      isExpand = rateData[index]["isExpand"] || false,
                      isViewAllRates =
                        rateDisplayDetails["expandedLineId"]?.includes(
                          LineId
                        ) ?? false,
                      limitedRateArray = !isViewAllRates
                        ? handleGetLimitedRateArray(
                            rateDisplayDetails,
                            [...rowData],
                            COlID,
                            totalAddons
                          )
                        : [];

                    return (
                      <View
                        pointerEvents={
                          // priceAvailability === "ratesExpired" ||
                          ["autoSelectingProduct", "pageLoading"].includes(
                            processingStatus
                          )
                            ? "none"
                            : "auto"
                        }
                        style={[styles["rateContainerWrapper"]]}
                        key={index}
                      >
                        <View
                        // style={[
                        //   web &&
                        //     priceAvailability === "ratesExpired" && {
                        //       filter: "blur(2px)",
                        //     },
                        //   !web &&
                        //     priceAvailability === "ratesExpired" && {
                        //       opacity: 0.5,
                        //     },
                        // ]}
                        >
                          <TouchableOpacity
                            activeOpacity={1}
                            onPress={() => {
                              setRateData((prevRateData) => {
                                prevRateData[index]["isExpand"] =
                                  !prevRateData[index]["isExpand"];
                                return [...prevRateData];
                              });
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              name={`chevron-${isExpand ? "down" : "right"}`}
                              size={28}
                            />
                            <CustomText style={[styles["productName"]]} bold>
                              {programName}
                            </CustomText>
                          </TouchableOpacity>
                          {isExpand && (
                            <View
                              style={[
                                styles["productRateTable"],
                                !(
                                  !web && priceAvailability === "ratesExpired"
                                ) &&
                                  generateBoxShadowStyle(
                                    2,
                                    6,
                                    "black",
                                    0.2,
                                    3,
                                    8,
                                    "black"
                                  ),
                              ]}
                              onLayout={handleLayout}
                            >
                              <View style={styles["rateTableHeader"]}>
                                <CustomText
                                  style={[
                                    styles["rateTableHeaderTitle"],
                                    styles["column1"],
                                  ]}
                                  bold
                                >
                                  <Icon
                                    name="chevron-right"
                                    color="#508bc9"
                                    size={20}
                                    style={{
                                      position: "relative",
                                      left: -10,
                                    }}
                                  />
                                  Interest Rate
                                </CustomText>
                                <CustomText
                                  style={[
                                    styles["rateTableHeaderTitle"],
                                    styles["columnAPR"],
                                  ]}
                                  bold
                                >
                                  APR
                                </CustomText>
                                <CustomText
                                  style={[
                                    styles["rateTableHeaderTitle"],
                                    styles["column2"],
                                  ]}
                                  bold
                                >
                                  Points
                                </CustomText>
                              </View>
                              <View>
                                <ScrollContainer>
                                  <View style={styles["rateTableBody"]}>
                                    {(priceAvailability === "priceChanged"
                                      ? [{}]
                                      : rowData
                                    )
                                      .filter(
                                        ({ [COlID]: Col }) =>
                                          parseInt(Col) !== 1000
                                      )
                                      .filter(({ Rate }) => {
                                        return isViewAllRates
                                          ? isViewAllRates
                                          : limitedRateArray.includes(
                                              Number(cleanValue(Rate))
                                            );
                                      })
                                      .map(
                                        (
                                          {
                                            Rate = "-",
                                            MonthlyPayment = "-",
                                            RateSheetName = "-",
                                            [COlID]: Col = "-",
                                          },
                                          iIndex
                                        ) => {
                                          Rate = cleanValue(Rate);
                                          const {
                                              // priceAvailability ===
                                              // "ratesExpired"
                                              //   ? Rate
                                              //   :
                                              APR = "Calculating",
                                            } =
                                              aprRateState?.[LineId]?.[Rate] ||
                                              {},
                                            cashToClose =
                                              cashToCloseDetails?.[LineId]?.[
                                                Rate
                                              ] || "Calculating",
                                            point = getPoints(
                                              parseFloat(Col) +
                                                totalAddons +
                                                LenderCompPoints
                                            ).toString();
                                          const { backgroundColor, active } =
                                              handleGetRowColor({
                                                index,
                                                LineId,
                                                Rate,
                                                iIndex,
                                              }),
                                            rowIdentity = `${LineId}-${Rate}`,
                                            isRowExpand =
                                              rowStatus.includes(rowIdentity);

                                          return (
                                            <RateRow
                                              onPress={() => {
                                                setRowStatus(
                                                  (prevRowStatus) => {
                                                    return [
                                                      ...prevRowStatus.filter(
                                                        (iRowIdentity) =>
                                                          iRowIdentity !==
                                                          selectedRate[
                                                            "rowIdentity"
                                                          ]
                                                      ),
                                                      rowIdentity,
                                                    ];
                                                  }
                                                );
                                                setSelectedRate({
                                                  RateSheetName,
                                                  Rate,
                                                  LineId,
                                                  LnProgActiveId,
                                                  points: point,
                                                  MonthlyPayment,
                                                  cashToClose:
                                                    cashToClose || "-",
                                                  LockPeriods,
                                                  BasePoints: parseFloat(Col),
                                                  RateSheetId,
                                                  programName,
                                                  rowIdentity,
                                                });
                                              }}
                                              backgroundColor={backgroundColor}
                                              key={iIndex}
                                              ref={active ? targetRef : null}
                                            >
                                              <View
                                                style={[
                                                  styles["rateTableRowChild"],
                                                ]}
                                              >
                                                <CustomText
                                                  style={[
                                                    styles["rateTableRowText"],
                                                    styles["column1"],
                                                    { textAlign: "left" },
                                                  ]}
                                                >
                                                  <Icon
                                                    name={`chevron-${
                                                      isRowExpand
                                                        ? "down"
                                                        : "right"
                                                    }`}
                                                    onPress={() => {
                                                      setRowStatus(
                                                        (prevRowStatus) => {
                                                          if (
                                                            prevRowStatus.includes(
                                                              rowIdentity
                                                            )
                                                          ) {
                                                            return prevRowStatus.filter(
                                                              (item) =>
                                                                item !==
                                                                rowIdentity
                                                            );
                                                          } else {
                                                            return [
                                                              ...prevRowStatus,
                                                              rowIdentity,
                                                            ];
                                                          }
                                                        }
                                                      );
                                                    }}
                                                    size={20}
                                                  />
                                                  {"   "}
                                                  {Rate !== "-" ? (
                                                    <>
                                                      {formatPercentage(Rate)}
                                                    </>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </CustomText>

                                                {APR == "Calculating" ? (
                                                  <View
                                                    style={[
                                                      {
                                                        height: 20,
                                                      },
                                                      styles["columnAPR"],
                                                    ]}
                                                  >
                                                    <ArrowSpinner
                                                      color="black"
                                                      isSpinner={true}
                                                      size={13}
                                                      style={{ marginTop: 10 }}
                                                    />
                                                  </View>
                                                ) : (
                                                  <CustomText
                                                    style={[
                                                      styles[
                                                        "rateTableRowText"
                                                      ],
                                                      styles["columnAPR"],
                                                    ]}
                                                  >
                                                    {formatPercentage(
                                                      cleanValue(APR)
                                                    )}
                                                  </CustomText>
                                                )}

                                                <CustomText
                                                  style={[
                                                    styles["rateTableRowText"],
                                                    styles["column2"],
                                                    {
                                                      color: point.includes("(")
                                                        ? "#246c23"
                                                        : "#c14242",
                                                    },
                                                  ]}
                                                >
                                                  {Rate !== "-" ? point : "-"}
                                                </CustomText>
                                              </View>
                                              {isRowExpand && (
                                                <>
                                                  <View
                                                    style={[
                                                      styles[
                                                        "rateTableRowChild"
                                                      ],
                                                      {
                                                        justifyContent:
                                                          "space-around",
                                                        marginBottom: 8,
                                                      },
                                                    ]}
                                                  >
                                                    <View
                                                      style={{
                                                        backgroundColor: active
                                                          ? "#c9dde9"
                                                          : "#EEF4FA",
                                                        borderRadius: 6,
                                                        paddingVertical: 7,
                                                        paddingHorizontal: 15,
                                                      }}
                                                    >
                                                      <CustomText
                                                        style={[
                                                          styles[
                                                            "rateTableRowText"
                                                          ],
                                                        ]}
                                                      >
                                                        {formatCurrency(
                                                          cleanValue(
                                                            MonthlyPayment
                                                          ),
                                                          2
                                                        )}
                                                      </CustomText>
                                                      <CustomText
                                                        style={[
                                                          styles[
                                                            "rateTableHeaderTitle"
                                                          ],
                                                          {
                                                            color: "black",
                                                            fontSize: web
                                                              ? 12
                                                              : 11,
                                                            marginTop: 5,
                                                          },
                                                        ]}
                                                      >
                                                        Monthly Payment
                                                      </CustomText>
                                                    </View>
                                                    <View
                                                      style={{
                                                        backgroundColor: active
                                                          ? "#c9dde9"
                                                          : "#EEF4FA",
                                                        borderRadius: 6,
                                                        paddingVertical: 7,
                                                        paddingHorizontal: 15,
                                                      }}
                                                    >
                                                      <CustomText
                                                        style={[
                                                          styles[
                                                            "rateTableRowText"
                                                          ],
                                                        ]}
                                                      >
                                                        {cashToClose ==
                                                        "Calculating" ? (
                                                          <View
                                                            style={[
                                                              {
                                                                height: 20,
                                                              },
                                                              styles[
                                                                "rateTableRowText"
                                                              ],
                                                            ]}
                                                          >
                                                            <ArrowSpinner
                                                              color="black"
                                                              isSpinner={true}
                                                              size={13}
                                                              style={{
                                                                marginTop: 10,
                                                              }}
                                                            />
                                                          </View>
                                                        ) : (
                                                          formatCurrency(
                                                            cleanValue(
                                                              cashToClose
                                                            )
                                                          )
                                                        )}
                                                      </CustomText>
                                                      <CustomText
                                                        style={[
                                                          styles[
                                                            "rateTableHeaderTitle"
                                                          ],
                                                          {
                                                            color: "black",
                                                            fontSize: web
                                                              ? 12
                                                              : 11,
                                                            marginTop: 5,
                                                          },
                                                        ]}
                                                      >
                                                        Cash to Close
                                                      </CustomText>
                                                    </View>
                                                  </View>
                                                  <Button
                                                    disabled={
                                                      priceAvailability &&
                                                      priceAvailability !==
                                                        "ratesExpired"
                                                    }
                                                    style={{
                                                      paddingVertical: 5,
                                                      paddingHorizontal: 10,
                                                      width: 160,
                                                      height: 35,
                                                      marginLeft: 0,
                                                      marginBottom: 10,
                                                    }}
                                                    onPress={() => {
                                                      setProcessingStatus(null);
                                                      if (!active) {
                                                        setSelectedRate({
                                                          RateSheetName,
                                                          Rate,
                                                          LineId,
                                                          LnProgActiveId,
                                                          points: point,
                                                          MonthlyPayment,
                                                          cashToClose:
                                                            cashToClose || "-",
                                                          LockPeriods,
                                                          BasePoints:
                                                            parseFloat(Col),
                                                          RateSheetId,
                                                          programName,
                                                          rowIdentity,
                                                        });
                                                      } else
                                                        targetRef.current.triggerPress();
                                                      setModalDetails({
                                                        visible: true,
                                                      });
                                                    }}
                                                    title={
                                                      <>
                                                        <CustomText
                                                          bold
                                                          style={{
                                                            fontSize: 15,
                                                            color: "#fff",
                                                          }}
                                                        >
                                                          Select This Rate
                                                        </CustomText>
                                                      </>
                                                    }
                                                  />
                                                </>
                                              )}
                                            </RateRow>
                                          );
                                        }
                                      )}
                                  </View>
                                </ScrollContainer>
                                <TouchableOpacity
                                  onPress={() => {
                                    setRateDisplayDetails(
                                      (prevRateDisplayDetails) => {
                                        return {
                                          ...prevRateDisplayDetails,
                                          expandedLineId: rateDisplayDetails[
                                            "expandedLineId"
                                          ].includes(LineId)
                                            ? rateDisplayDetails[
                                                "expandedLineId"
                                              ].filter(
                                                (item) => item !== LineId
                                              )
                                            : [
                                                ...rateDisplayDetails[
                                                  "expandedLineId"
                                                ],
                                                LineId,
                                              ],
                                        };
                                      }
                                    );
                                  }}
                                  activeOpacity={0.7}
                                  style={{
                                    backgroundColor: "#fafafa",
                                    padding: 5,
                                    borderTopWidth: 1,
                                    borderTopColor: "#cccccc",
                                  }}
                                >
                                  <CustomText
                                    style={{
                                      color: "#2672CB",
                                      alignSelf: "center",
                                      fontSize: web ? 16 : 14,
                                    }}
                                  >
                                    View {!isViewAllRates ? "all" : "suggested"}{" "}
                                    rates
                                  </CustomText>
                                </TouchableOpacity>
                              </View>
                            </View>
                          )}
                        </View>
                      </View>
                    );
                  })}
                </>
              ) : (
                processingStatus && (
                  <View style={{ minHeight: 250 }}>
                    <View
                      style={[
                        styles["rateContainerWrapper"],
                        {
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "row",
                        },
                      ]}
                    >
                      <View
                        style={{
                          width: 20,
                        }}
                      >
                        <ArrowSpinner
                          color="#508BC9"
                          isSpinner={true}
                          size={20}
                        />
                      </View>
                      <CustomText
                        style={[styles["rateTableRowText"], { fontSize: 14 }]}
                      >
                        {"  "}
                        {["searchingProducts", "savingProducts"].includes(
                          processingStatus
                        ) ? (
                          <>
                            {" "}
                            {
                              processingStatus === "searchingProducts"
                                ? "Searching Loan Products..."
                                : "Searching Loan Products..."
                              // "Saving Filter Details..."
                            }
                          </>
                        ) : processingStatus === "autoSelectingProduct" ? (
                          "Finding the best loan product for you!"
                        ) : (
                          "Loading..."
                        )}
                      </CustomText>
                    </View>
                  </View>
                )
              )}
              <View style={{ minHeight: web ? 180 : 300 }}></View>
            </ScrollContainer>
            {/* {["changeRate", "floatDown"].includes(processName) && (
              <>
                <View
                  style={{
                    position: web ? "fixed" : "relative",
                    bottom: web
                      ? 110
                      : 70 +
                        (["changeRate", "floatDown"].includes(processName)
                          ? 45
                          : 0),
                    paddingVertical: 15,
                    width: !web ? "100%" : isMobileWeb ? "91.5%" : 420,
                    backgroundColor: "#fff",
                    borderTopWidth: 1,
                    borderTopColor: "#cccccc",
                  }}
                >
                  <Button
                    buttonType="secondary"
                    disabled={false}
                    style={{
                      marginTop: 10,
                      width: "75%",
                    }}
                    onPress={() => {
                      setProcessingStatus(null);
                      setLockConfirmationDetails(
                        (prevLockConfirmationDetails) => {
                          delete prevLockConfirmationDetails["processName"];
                          return {
                            ...prevLockConfirmationDetails,
                            isLocked: true,
                          };
                        }
                      );
                    }}
                    title={
                      <>
                        <CustomText
                          bold
                          style={{
                            fontSize: 14,
                            color: "#508BC9",
                          }}
                        >
                          Cancel
                        </CustomText>
                      </>
                    }
                  />
                </View>
              </>
            )} */}
            <View
              style={{
                position: web ? "fixed" : "relative",
                bottom: web
                  ? 110
                  : 70 +
                    (["changeRate", "floatDown"].includes(processName)
                      ? 45
                      : 0),
                paddingVertical: 15,
                width: !web ? "100%" : isMobileWeb ? "91.5%" : 420,
                backgroundColor: "#fff",
                borderTopWidth: 1,
                borderTopColor: "#cccccc",
              }}
            >
              <Button
                disabled={
                  (priceAvailability && priceAvailability !== "ratesExpired") ||
                  Object.keys(selectedRate).length === 0 ||
                  [
                    "searchingProducts",
                    "savingProducts",
                    "pageLoading",
                    "autoSelectingProduct",
                  ].includes(processingStatus)
                }
                onPress={() => {
                  setProcessingStatus(null);

                  targetRef.current.triggerPress();
                  setModalDetails({
                    visible: true,
                  });
                }}
                style={{ width: "75%" }}
                title={
                  <>
                    <CustomText
                      bold
                      style={{
                        fontSize: 19,
                        color: "#fff",
                      }}
                    >
                      Select Rate
                    </CustomText>
                  </>
                }
              />
              {["changeRate", "floatDown"].includes(processName) && (
                <>
                  <Button
                    buttonType="secondary"
                    disabled={false}
                    style={{
                      marginTop: 10,
                      width: "75%",
                    }}
                    onPress={() => {
                      setProcessingStatus(null);
                      setLockConfirmationDetails(
                        (prevLockConfirmationDetails) => {
                          delete prevLockConfirmationDetails["processName"];
                          return {
                            ...prevLockConfirmationDetails,
                            isLocked: true,
                          };
                        }
                      );
                    }}
                    title={
                      <>
                        <CustomText
                          bold
                          style={{
                            fontSize: 14,
                            color: "#508BC9",
                          }}
                        >
                          Cancel
                        </CustomText>
                      </>
                    }
                  />
                </>
              )}
            </View>
          </>
        ) : (
          <></>
        )}
      </View>
      {!alertDetails["visible"] && modalDetails["visible"] && ModalComponent}
      {!modalDetails["visible"] && alertDetails["visible"] && AlertComponent}
    </>
  );
};

const styles = StyleSheet.create({
  titleWrapper: {
    ...{
      padding: web ? 10 : 5,
      backgroundColor: "#395D82",
    },
    ...(web
      ? {
          boxShadow: "0px 6px 12px 0px #00000059",
        }
      : {}),
  },
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      // outlineWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
    },
  },
  title: {
    fontSize: web ? 20 : 18,
    marginBottom: web ? 10 : 10,
    alignSelf: "center",
    color: "#fff",
  },
  titleDescription: {
    fontSize: 9,
    color: "#fff",
    alignSelf: "center",
  },
  filterWrapper: {
    borderWidth: 1,
    borderColor: "black",
    padding: 10,
    marginTop: 15,
    backgroundColor: "#FAFAFA",
  },
  filterContainerWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    alignItems: "flex-start",
  },
  filetHeader: {
    alignSelf: "center",
    fontSize: 13,
    paddingBottom: 13,
    flexDirection: "row",
  },
  filterHead: {
    fontSize: 10,
    color: "#4D4D4D",
    paddingBottom: 5,
    textAlign: "center",
  },
  filterContainer: { color: "#4D4D4D" },
  rateContainerWrapper: {
    marginTop: 20,
    borderWidth: 1,
    borderColor: "#96b9de",
    backgroundColor: "#dce8f4",
    padding: 10,
  },
  productName: {
    fontSize: 15,
  },
  productRateTable: [
    {
      marginTop: 10,
      borderWidth: 1,
      borderColor: "#96b9de",
      shadowColor: "rgba(0, 0, 0, 0.30)",
      shadowRadius: 10,
      shadowOpacity: 0.5,
    },
  ],
  rateTableHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#508BC9",
    textAlign: "center",
    paddingHorizontal: 5,
    paddingTop: 5,
    paddingBottom: 7,
  },
  rateTableHeaderTitle: {
    color: "#fff",
    fontSize: web ? 15 : 13,
    textAlign: "center",
  },
  tableRow: {
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 10,
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  cellOne: {
    fontSize: 10,
    color: "#595959",
    lineHeight: 15,
    textAlign: "center",
  },
  cellTwo: {
    color: "#595959",
    fontSize: 10,
    flex: 1,
  },
  rateTableBody: {
    ...{},
    ...(web
      ? {
          // overflow: "auto",
        }
      : {}),
  },
  rateTableRow: {
    flexDirection: "row",
    alignItems: "center",
    flexDirection: "column",
    // padding: 5,
  },
  rateTableRowText: {
    ...{
      color: "black",
      fontSize: web ? 16 : 14,
      textAlign: "center",
    },
    ...(web ? { fontWeight: 500 } : {}),
  },
  rateTableRowChild: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
  },
  column1: {
    width: "35%",
  },
  columnAPR: {
    width: "23%",
  },
  column2: {
    width: web ? "25%" : "22%",
  },
  column3: {
    width: "20%",
  },
  column4: {
    width: web ? "31%" : "25%",
  },
  rateSummary: {
    color: "#646464", //"#395D82",
    alignSelf: "center",
    fontSize: web ? 22 : 20,
    marginBottom: 15,
    marginTop: 10,
    textAlign: "center",
  },
  rateSummaryRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignSelf: "center",
    width: "85%",
    paddingVertical: 10,
  },
  rateValue: {
    alignSelf: "center",
    fontSize: web ? 19 : 17,
    color: "#404040",
    marginBottom: 3,
  },
  rateValueLabel: {
    ...{
      alignSelf: "center",
      fontSize: web ? 14 : 12,
      color: "#696767",
      textAlign: "center",
    },
    ...(web ? { fontWeight: 500 } : {}),
  },
  rateValueWrapper: { width: 110, textAlign: "center" },
  rateSummaryContainer: {
    backgroundColor: "#F2F2F2",
    borderRadius: 8,
    marginBottom: 15,
    height: 53,
    paddingVertical: 10,
    marginHorizontal: 15,
    justifyContent: "space-around",
  },
  rateText: { alignSelf: "center", fontSize: web ? 14 : 12 },
  rateTextLabel: { alignSelf: "center", fontSize: web ? 12 : 10 },
});

export default InterestRate;
